<template>
  <v-container fluid>
    <!-- Role 31: Both data table and calendar -->
    <div v-if="isDeliveriesManager || isAdmin">
        <v-row>
          <v-col>
            <v-card elevation="0" outlined>
              <v-card-title>
                <v-row>
                  <v-col cols="auto">Delivery Requests</v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="filterRequestType"
                      label="Type"
                      :items="requestTypes"
                      item-text="name"
                      item-value="id"
                      dense
                      hide-details
                      :loading="requestTypesLoading"
                      clearable
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="filterRequestShift"
                      label="Shift"
                      :items="requestShifts"
                      item-text="name"
                      item-value="id"
                      dense
                      hide-details
                      :loading="requestShiftsLoading"
                      clearable
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="filterRequestStatus"
                      label="Status"
                      :items="requestStatuses"
                      item-text="name"
                      item-value="id"
                      dense
                      hide-details
                      :loading="requestStatusesLoading"
                      multiple
                      clearable
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer;"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      outlined
                      @click="openTruckRequestForm(null)"
                    >
                      <v-icon small class="mr-1">fas fa-plus</v-icon>
                      Delivery Request
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-title class="pa-0">
                <v-row>
                  <v-col
                    cols="auto"
                  >
                    <v-tabs
                      v-model="activeArchivedTab"
                    >
                      <v-tab>
                        ACTIVE
                      </v-tab>
                      <v-tab>
                        ARCHIVED
                      </v-tab>
                    </v-tabs>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="truckRequests"
                :footer-props="footer"
                :items-per-page="pagination.itemsPerPage"
                :search="search"
                :loading="loadingTruckRequests"
                dense
                fixed-header
                :height="windowHalfHeight"
                :server-items-length="total"
                @update:options="updateOptions"
              >
                <template #item="{ item }">
                  <tr :ref="`row-${item.id}`" :key="item.id">
                    <td>
                      <v-tooltip top>
                        <template #activator="{ on, attrs }">
                          <div v-on="on">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              icon
                              draggable="true"
                              @dragstart="onDragStart($event, item, item.id)"
                              @dragend="onDragEnd"
                              :disabled="truckRequestIsScheduled(item) || truckRequestIsCanceled(item) || truckRequestIsRequested(item) || truckRequestIsPendingApproval(item)"
                            >
                              <v-icon small> fa-solid fa-bars </v-icon>
                            </v-btn>
                          </div>
                        </template>
                        <span v-if="truckRequestIsRequested(item) && (!isDeliveriesManager || !isAdmin)">
                          Delivery Manager must Approve the Request First
                        </span>
                        <span v-else-if="truckRequestIsPendingApproval(item) && (!isDeliveriesRequester || !isAdmin)">
                          Delivery Requester must Approve the Request First
                        </span>
                        <span v-else-if="truckRequestIsScheduled(item) || truckRequestIsCanceled(item)">
                          Delivery Request Already Scheduled
                        </span>
                        <span v-else> Drag to + Button to Schedule </span>
                      </v-tooltip>
                    </td>
                    <td class="text-center">
                      <template v-if="item.inventory_classes && item.inventory_classes.length > 1">
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >CLASSES</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="class_item in item.inventory_classes"
                                :key="class_item.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <v-chip
                                    class="mt-1 mb-1"
                                    small
                                    text-color="white"
                                    style="cursor: pointer"
                                    :color="
                                      class_item ? class_item.color : 'white'
                                    "
                                  >
                                    {{ class_item ? class_item.name : '' }}
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </template>
                      <v-chip
                        v-else-if="item.inventory_classes && item.inventory_classes.length === 1"
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item.inventory_classes[0]
                            ? item.inventory_classes[0].color
                            : 'white'
                        "
                      >
                        {{
                          item.inventory_classes[0] ? item.inventory_classes[0].name : ''
                        }}
                      </v-chip>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td class="text-center">{{ item.id }}</td>
                    <td class="text-center">
                      <v-chip
                        v-if="item.request_type"
                        small
                        :style="{
                          background:
                            item && item.request_type ? item.request_type.color : 'grey',
                        }"
                        text-color="white"
                      >
                        {{ item && item.request_type ? item.request_type.name : '' }}
                      </v-chip>
                    </td>
                    <td>
                      <template
                        v-if="item.projects && item.projects.length > 1"
                      >
                      <!-- <v-row
                        v-if="item.projects && item.projects.length > 1"
                      >
                        <v-col class="pl-1"> -->
                          <v-tooltip top color="black">
                            <template #activator="{ on }">
                              <span style="color: #1976d2" v-on="on"
                                >PROJECTS</span
                              >
                            </template>
                            <v-row>
                              <v-col class="text-center pt-6 pb-6">
                                <v-row
                                  v-for="project_item in item.projects"
                                  :key="project_item.id"
                                >
                                  <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                    {{ project_item ? project_item.name : '' }}
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-tooltip>
                        <!-- </v-col>
                      </v-row> -->
                      </template>
                      <span
                        v-else-if="item.projects && item.projects.length === 1"
                      >
                        {{
                          item.projects[0] ? item.projects[0].name : ''
                        }}
                      </span>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td>
                      <template
                        v-if="item.jobs && item.jobs.length > 1"
                      >
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >JOBS</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="job_item in item.jobs"
                                :key="job_item.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <span style="font-weight: bold">
                                    <text-highlight :queries="search">{{
                                      job_item.code ? `${job_item.code}` : ''
                                    }}</text-highlight>
                                  </span>
                                  <text-highlight :queries="search">
                                    -
                                    {{
                                      job_item.project &&
                                      job_item.project.name
                                        ? job_item.project.name
                                        : job_item.job &&
                                          job_item.job.name
                                        ? job_item.job.name
                                        : ''
                                    }}</text-highlight
                                  >
                                  <span style="color: #1976d2">
                                    <text-highlight :queries="search">{{
                                      job_item.reference ? `; ${job_item.reference}` : ''
                                    }}</text-highlight>
                                  </span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </template>
                      <template
                        v-else-if="item.jobs && item.jobs.length === 1"
                      >
                        <span style="font-weight: bold">
                          <text-highlight :queries="search">{{
                            item.jobs[0].code ? `${item.jobs[0].code}` : ''
                          }}</text-highlight>
                        </span>
                        <text-highlight :queries="search">
                          -
                          {{
                            item.jobs[0].project &&
                            item.jobs[0].project.name
                              ? item.jobs[0].project.name
                              : item.jobs[0].job &&
                                item.jobs[0].job.name
                              ? item.jobs[0].job.name
                              : ''
                          }}</text-highlight
                        >
                        <span style="color: #1976d2">
                          <text-highlight :queries="search">{{
                            item.jobs[0].reference ? `; ${item.jobs[0].reference}` : ''
                          }}</text-highlight>
                        </span>
                      </template>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <!-- <td class="text-center">
                      <v-chip
                        v-if="item.truck_type"
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item.truck_type
                            ? item.truck_type.color
                            : 'white'
                        "
                      >
                        {{
                          item.truck_type ? item.truck_type.name : ''
                        }}
                      </v-chip>
                      <span v-else>
                        -
                      </span>
                    </td> -->
                    <td class="text-center">
                      <template v-if="item.truck_types && item.truck_types.length > 1">
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >TRUCK TYPES</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="truck_type in item.truck_types"
                                :key="truck_type.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <v-chip
                                    class="mt-1 mb-1"
                                    small
                                    text-color="white"
                                    style="cursor: pointer"
                                    :color="
                                      truck_type ? truck_type.color : 'white'
                                    "
                                  >
                                    {{ truck_type ? truck_type.name : '' }}
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </template>
                      <v-chip
                        v-else-if="item.truck_types && item.truck_types.length === 1"
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item.truck_types[0]
                            ? item.truck_types[0].color
                            : 'white'
                        "
                      >
                        {{
                          item.truck_types[0] ? item.truck_types[0].name : ''
                        }}
                      </v-chip>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <!-- <td class="text-center">
                       <v-chip
                        v-if="item.truck"
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item.truck
                            ? item.truck.color
                            : 'white'
                        "
                      >
                        <text-highlight :queries="search">
                          {{ item.truck ? item.truck.name : '' }}
                        </text-highlight>
                      </v-chip>
                      <span v-else>
                        -
                      </span>
                    </td> -->
                    <td class="text-center">
                      <template v-if="item.slot && item.slot.trucks && item.slot.trucks.length > 1">
                        <v-tooltip top color="black">
                          <template #activator="{ on }">
                            <span style="color: #1976d2" v-on="on"
                              >TRUCKS</span
                            >
                          </template>
                          <v-row>
                            <v-col class="text-center pt-6 pb-6">
                              <v-row
                                v-for="truck in item.slot.trucks"
                                :key="truck.id"
                              >
                                <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                  <v-chip
                                    class="mt-1 mb-1"
                                    small
                                    text-color="white"
                                    style="cursor: pointer"
                                    :color="
                                      truck ? truck.color : 'white'
                                    "
                                  >
                                    {{ truck ? truck.name : '' }}
                                  </v-chip>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-tooltip>
                      </template>
                      <v-chip
                        v-else-if="item.slot && item.slot.trucks && item.slot.trucks.length === 1"
                        class="mt-1 mb-1"
                        small
                        text-color="white"
                        style="cursor: pointer"
                        :color="
                          item.slot.trucks[0]
                            ? item.slot.trucks[0].color
                            : 'white'
                        "
                      >
                        {{
                          item.slot.trucks[0] ? item.slot.trucks[0].name : ''
                        }}
                      </v-chip>
                      <span v-else>
                        -
                      </span>
                    </td>
                    <td>
                      <text-highlight :queries="search">
                        {{ item && item.date ? item.date : '-' }}
                      </text-highlight>
                    </td>
                    <td>
                      <text-highlight :queries="search">
                        {{ item && item.slot ? item.slot.date : '-' }}
                      </text-highlight>
                    </td>
                    <td>
                      <text-highlight :queries="search">
                        {{
                          item && item.created_by_user_full_name
                            ? item.created_by_user_full_name
                            : '-'
                        }}
                      </text-highlight>
                    </td>
                    <td class="text-center">
                      <v-chip
                        small
                        :style="{
                          background:
                            item && item.request_shift ? item.request_shift.color : 'grey',
                        }"
                        text-color="white"
                      >
                        <text-highlight :queries="search">
                          {{ item && item.request_shift ? item.request_shift.name : '' }}
                        </text-highlight>
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <!-- <template v-if="item.status_id === truckScheduleStatusIdShipped">
                        <v-tooltip top>
                          <template #activator="{ on, attrs }">
                            <v-chip
                              v-on="on"
                              v-attrs="attrs"
                              small
                              :style="{
                                background:
                                  item && item.status ? item.status.color : 'grey',
                              }"
                              text-color="white"
                            >
                              <text-highlight :queries="search">
                                {{ item && item.status ? item.status.name : '' }}
                              </text-highlight>
                            </v-chip>
                          </template>
                          <span>
                            {{ `${item.current_shipped_finished_goods_count}/${item.total_finished_goods_count}` }}
                          </span>
                        </v-tooltip>
                      </template> -->
                      <template>
                        <v-chip
                          small
                          :style="{
                            background:
                              item && item.status ? item.status.color : 'grey',
                          }"
                          text-color="white"
                        >
                          <text-highlight :queries="search">
                            {{ item && item.status ? item.status.name : '' }}
                          </text-highlight>
                        </v-chip>
                      </template>
                    </td>
                    <td class="text-right">
                      <v-btn
                        v-if="(truckRequestIsRequested(item) || truckRequestIsPendingApproval(item)) && !isTruckRequestArchived(item)"
                        class="ml-1 mt-1 mb-1"
                        color="#D81B60"
                        outlined
                        small
                        @click="approveTruckRequest(item)"
                      >
                        APPROVE
                      </v-btn>
                      <v-btn
                        v-if="item.request_shift_id !== truckScheduleRequestShiftIdPending && item.request_type_id === truckScheduleRequestTypeIdPickup && item.status_id !== truckScheduleStatusIdComplete && item.slot !== null && !isTruckRequestArchived(item)"
                        class="ml-1 mt-1 mb-1"
                        color="primary"
                        outlined
                        small
                        @click="completeTruckRequest(item)"
                      >
                        COMPLETE
                      </v-btn>
                      <v-btn
                        v-if="item.bill_of_ladings.length > 0"
                        class="ml-1 mt-1 mb-1"
                        color="success"
                        outlined
                        small
                        @click="openBillOfLadingList(item)"
                      >
                        BOL
                      </v-btn>
                      <v-btn
                        v-if="!truckRequestIsScheduled(item) && !truckRequestIsCanceled(item) && truckRequestIsPendingScheduling(item) && !isTruckRequestArchived(item)"
                        class="ml-1 mt-1 mb-1"
                        color="purple"
                        outlined
                        small
                        @click="openManualScheduleForm(item)"
                      >
                        SCHEDULE
                      </v-btn>
                      <v-btn
                        v-if="isTruckRequestApproved(item)"
                        class="ml-1 mt-1 mb-1"
                        color="primary"
                        outlined
                        small
                        @click="openTruckRequestForm(item, true)"
                      >
                        VIEW
                      </v-btn>
                      <!-- <v-btn
                        v-if="truckRequestIsCanceled(item)" 
                        class="ml-1 mt-1 mb-1"
                        color="error"
                        outlined
                        small
                        @click="softDeleteTruckRequest(item)"
                      >
                        DELETE
                      </v-btn> -->
                      <v-menu
                        offset-y
                      >
                        <template #activator="{ on, attrs }">
                          <v-btn
                            class="ml-1 mt-1 mb-1"
                            elevation="0"
                            fab
                            outlined
                            x-small
                            v-bind="attrs"
                            tile
                            color="primary"
                            style="
                              border-radius: 7px;
                              width: 28px !important;
                              height: 28px !important;
                            "
                            v-on="on"
                          >
                            <v-icon> mdi-dots-vertical </v-icon>
                          </v-btn>
                        </template>
                        <v-list class="pa-3">
                          <v-list-item
                            v-if="truckRequestIsScheduled(item) && !isTruckRequestArchived(item)"
                            @click="openManualScheduleForm(item)">
                            <v-list-item-title
                              :style="`color: orange; font-weight: 600;`"
                            >
                              <v-row align="center">
                                <v-col
                                  cols="auto"
                                  class="pr-0"
                                  style="white-space: nowrap"
                                />
                                <v-col class="pt-4"> RESCHEDULE </v-col>
                              </v-row>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && !truckRequestIsCanceled(item) && !isTruckRequestArchived(item)"
                            :disabled="isTruckRequestEditDisabled(item)"
                            @click="openTruckRequestForm(item)">
                            <v-list-item-title
                              :style="`color: ${isTruckRequestEditDisabled(item) ? 'rgba(0, 0, 0, 0.38)' : 'green'}; font-weight: 600;`"
                            >
                              <v-row align="center">
                                <v-col
                                  cols="auto"
                                  class="pr-0"
                                  style="white-space: nowrap"
                                />
                                <v-col class="pt-4"> EDIT </v-col>
                              </v-row>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            @click="toggleArchive(item)"
                           >
                            <v-list-item-title
                              :style="`color: purple; font-weight: 600;`"
                            >
                              <v-row align="center">
                                <v-col
                                  cols="auto"
                                  class="pr-0"
                                  style="white-space: nowrap"
                                />
                                <v-col class="pt-4">  {{ item.is_archived === 0 ? 'ARCHIVE' : 'ACTIVATE' }} </v-col>
                              </v-row>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && !truckRequestIsCanceled(item) && !isTruckRequestArchived(item)"
                            @click="cancelTruckRequest(item)"
                           >
                            <v-list-item-title
                              :style="`color: red; font-weight: 600;`"
                            >
                              <v-row align="center">
                                <v-col
                                  cols="auto"
                                  class="pr-0"
                                  style="white-space: nowrap"
                                />
                                <v-col class="pt-4"> CANCEL </v-col>
                              </v-row>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item
                            v-if="truckRequestIsCanceled(item)"
                            @click="softDeleteTruckRequest(item)"
                           >
                            <v-list-item-title
                              :style="`color: red; font-weight: 600;`"
                            >
                              <v-row align="center">
                                <v-col
                                  cols="auto"
                                  class="pr-0"
                                  style="white-space: nowrap"
                                />
                                <v-col class="pt-4"> DELETE </v-col>
                              </v-row>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0">
            <v-card elevation="0" outlined>
              <v-card-title>
                <v-row>
                  <v-col cols="auto"> Scheduled Deliveries </v-col>
                  <v-col cols="1">
                    <v-select
                      v-model="calendarType"
                      :items="calendarTypes"
                      dense
                      hide-details
                      label="Type"
                      item-value="type"
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="auto" class="pt-4 pl-0">
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title }}
                    </v-toolbar-title>
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto">
                    <v-btn
                      color="success"
                      outlined
                      @click="openGenerateReportDialog"
                    >
                        REPORT
                    </v-btn>
                    <the-dialog-box
                      ref="dialogBox"
                      :submit="runWebhook"
                      submit-btn-text="Generate"
                      :max-width="600"
                      :scrollable="false"
                      :persistent="true"
                    >
                      <template slot="header">
                        <span>Generate Scheduled Delivery PDF Report</span>
                      </template>
                      <template slot="body">
                          <v-row>
                            <v-col
                              cols="12"
                            >
                              <v-date-picker
                                v-model="webhookDates"
                                full-width
                                range
                              ></v-date-picker>
                              <v-text-field
                                v-model="dateRangeText"
                                label="Date range"
                                prepend-icon="mdi-calendar"
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                      </template>
                    </the-dialog-box>
                  </v-col>
                  <v-col cols="auto" class="pa-0">
                    <v-btn fab icon color="grey darken-2" @click="prev">
                      <v-icon x-large> mdi-chevron-left </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" class="pa-0">
                    <v-btn fab icon color="grey darken-2" @click="next">
                      <v-icon x-large> mdi-chevron-right </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
              <div class="calendar-container">
                <v-calendar
                  ref="calendar"
                  v-model="focusDay"
                  :weekdays="weekday"
                  :type="calendarType"
                  :event-more="false"
                  :events="events"
                  event-overlap-mode="column"
                  interval-count="0"
                  color="primary"
                  @change="onDateRangeChange"
                  @dragover.prevent
                  @drop="onCalendarDrop"
                >
                  <template #day-label-header="dayLabelHeader">
                    <!-- for week and day view  -->
                    <v-row>
                      <v-col
                        v-if="holidaysObj[dayLabelHeader.date]"
                        style="font-weight: bold"
                      >
                        {{ holidaysObj[dayLabelHeader.date] }}
                      </v-col>
                      <v-col v-else>
                        {{ dayLabelHeader.day }}
                      </v-col>
                    </v-row>
                    <div class="day-header-actions">
                      <!-- Centered Drop Button -->
                      <v-tooltip top>
                        <template #activator="{ on, attrs }">
                          <div class="text-center" v-on="on">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              id="drop-event-btn"
                              :class="`m-2 ${dropEventColorClass(dayLabelHeader.date)} ${draggingOverClass(dayLabelHeader.date)}`"
                              :outlined="isDraggingOverDate !== dayLabelHeader.date"
                              medium
                              label
                              @dragover="onDragOver($event, dayLabelHeader.date)"
                              @dragleave="onDragLeave"
                              @drop="onDropNewEvent($event, dayLabelHeader)"
                              :disabled="
                                isAddEventDisabled ||
                                dayLabelHeader.date < currentDate
                              "
                            >
                              DROP NEW DELIVERY HERE
                            </v-btn>
                          </div>
                        </template>
                        <span>
                          Drag a Truck Request here to Create a New Scheduled Delivery
                        </span>
                      </v-tooltip>

                      <!-- Right-aligned truck indicator -->
                      <div class="truck-indicator">
                        <v-progress-circular
                          v-if="loadingAvailableTrucksByDate"
                          indeterminate
                          :size="20"
                          :width="2"
                          class="v-progress-circular--visible"
                        />
                        
                        <v-tooltip
                          v-else-if="
                            availableTrucksByDate[dayLabelHeader.date] !== undefined &&
                            getTotalAvailableTrucksCount(dayLabelHeader.date) > 0"
                          top
                          color="black"
                        >
                          <template #activator="{ on }">
                            <div class="d-flex align-center" v-on="on">
                              <v-icon medium>mdi-truck-outline</v-icon>
                              <v-badge
                                offset-x="6"
                                offset-y="0"
                                :content="getTotalAvailableTrucksCount(dayLabelHeader.date)"
                                color="green"
                              />
                            </div>
                          </template>

                          <div class="pa-2" style="min-width: 350px;">
                            <v-simple-table dark dense>
                              <thead>
                                <tr>
                                  <th class="text-left">Truck Type</th>
                                  <th class="text-center">Total</th>
                                  <th class="text-center">Unavailable</th>
                                  <th class="text-center">Pending</th>
                                  <th class="text-center">Available</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr
                                  v-for="item in availableTrucksByDate[dayLabelHeader.date]"
                                  :key="item.truck_type_id"
                                >
                                  <td class="text-left">
                                    <v-chip
                                      small
                                      text-color="white"
                                      :color="item.truck_type ? item.truck_type.color : 'white'"
                                    >
                                      {{ item.truck_type ? item.truck_type.name : '' }}
                                    </v-chip>
                                  </td>

                                  <td class="text-center">
                                    {{ item.total_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    {{ item.unavailable_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    {{ item.pending_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    <strong>
                                      {{ item.available_count || item.count || 0 }}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </v-tooltip>

                        <v-icon v-else>mdi-truck-remove-outline</v-icon>
                      </div>
                    </div>
                  </template>
                  <template #day-label="dayLabel">
                    <!-- For Month View -->
                    <v-row>
                      <v-col
                        v-if="holidaysObj[dayLabel.date]"
                        style="font-weight: bold"
                      >
                        {{ holidaysObj[dayLabel.date] }}
                      </v-col>
                      <v-col v-else>
                        {{ dayLabel.day }}
                      </v-col>
                    </v-row>
                    <!-- For Month View -->
                    <v-tooltip top>
                      <template #activator="{ on, attrs }">
                        <div v-on="on" class="mt-2 mb-2">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            id="drop-event-btn"
                            :class="`${dropEventColorClass(dayLabel.date)} ${draggingOverClass(dayLabel.date)}`"
                            :outlined="isDraggingOverDate !== dayLabel.date"
                            medium
                            label
                            @dragover="onDragOver($event, dayLabel.date)"
                            @dragleave="onDragLeave"
                            @drop="onDropNewEvent($event, dayLabel)"
                            :disabled="
                              isAddEventDisabled ||
                              dayLabel.date < currentDate
                            "
                          >
                            DROP NEW DELIVERY HERE
                          </v-btn>
                        </div>
                      </template>
                      <span>
                        Drag a Truck Request here to Create a New Scheduled
                        Delivery
                      </span>
                    </v-tooltip>
                    <!-- Right-aligned truck indicator -->
                    <!-- <div class="truck-indicator">
                      <v-progress-circular
                        v-if="loadingAvailableTrucksByDate"
                        indeterminate
                        :size="20"
                        :width="2"
                        class="v-progress-circular--visible"
                      />
                      
                      <v-tooltip
                        v-else-if="
                          availableTrucksByDate[dayLabel.date] !== undefined &&
                          getTotalAvailableTrucksCount(dayLabel.date) > 0"
                        top
                        color="black"
                      >
                        <template #activator="{ on }">
                          <div class="d-flex align-center" v-on="on">
                            <v-icon medium>mdi-truck-outline</v-icon>
                            <v-badge
                              offset-x="6"
                              offset-y="0"
                              :content="getTotalAvailableTrucksCount(dayLabel.date)"
                              color="green"
                            />
                          </div>
                        </template>

                        <v-row>
                          <v-col class="text-center pt-6 pb-6">
                            <v-row
                              v-for="item in availableTrucksByDate[dayLabel.date]"
                              :key="item.truck_type_id"
                            >
                              <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                <v-chip
                                  small
                                  text-color="white"
                                  :color="item.truck_type ? item.truck_type.color : 'white'"
                                >
                                  {{ item.truck_type ? item.truck_type.name : '' }}
                                </v-chip>
                                <span style="font-size: 0.8rem; font-weight: bold; margin-left: 2px;">
                                  : {{ item.count }}
                                </span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-tooltip>

                      <v-icon v-else>mdi-truck-remove-outline</v-icon>
                    </div> -->
                  </template>
                  <!-- Slot for customizing events -->
                  <template #event="{ event, attrs }">
                    <v-card
                      class="calendar-event pr-1 pl-1"
                      :style="{ color: 'black', background: `${getEventBackgroundColor(event)}`, border: '1px solid #e0e0e0', borderLeft: `8px solid ${getEventBorderColor(event)}`, borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: `${getEventHeight(event)}px` }"
                      tile
                      :data-event-id="event.id"
                      @click="openScheduledDeliveryForm(event)"
                      v-bind="attrs"
                    >
                      <v-card-title class="pa-1">
                        <v-row class="px-0" justify="center" align="center">
                          <v-col class="px-2" cols="auto">
                            <v-chip
                              label
                              small
                              :color="
                                event && event.status ? lightenColor(event.status.color) : ''
                              "
                              :style="{fontWeight: 'bold'}"
                              :text-color="event && event.status ? event.status.color : ''"
                            >
                              {{
                                event && event.status ? event.status.name : ''
                              }}
                            </v-chip>
                          </v-col>
                          <v-col :class="'truncate-text pr-2 pl-0'">
                            <span :style="{ fontSize: '.8rem' }">
                              {{ event.name }}
                              <span v-if="isScheduledDeliveryPending(event)" style="color:#1976D2;">
                                PENDING
                              </span>
                            </span>
                          </v-col>
                          <v-col cols="auto">
                            <template v-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length > 1">
                              <v-tooltip top color="black">
                                <template #activator="{ on }">
                                  <span :style="{ fontSize: '.8rem !important', color: '#1976d2' }" v-on="on">
                                    CLASSES
                                  </span>
                                </template>
                                <v-row>
                                  <v-col class="text-center pt-6 pb-6">
                                    <v-row
                                      v-for="class_item in event.request.inventory_classes"
                                      :key="class_item.id"
                                    >
                                      <v-col cols="auto" class="pb-1 pt-1">
                                        <v-chip
                                          class="mt-1 mb-1"
                                          small
                                          text-color="white"
                                          style="cursor: pointer"
                                          :color="
                                            class_item ? class_item.color : 'white'
                                          "
                                        >
                                          {{ class_item ? class_item.name : '' }}
                                        </v-chip>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-tooltip>
                            </template>
                            <v-chip
                              v-else-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length === 1"
                              class="mt-1 mb-1"
                              small
                              text-color="white"
                              style="cursor: pointer"
                              :color="
                                event.request.inventory_classes[0]
                                  ? event.request.inventory_classes[0].color
                                  : 'white'
                              "
                            >
                              {{
                                event.request.inventory_classes[0] ? event.request.inventory_classes[0].name : ''
                              }}
                            </v-chip>
                            <span v-else>
                              -
                            </span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                        <v-list
                          class="pa-0"
                          :style="{
                            backgroundColor: 'transparent',
                            }"
                        >
                          <template v-for="(item, index) in event && event.request ? mapJobsAndProjectsToListItem(event.request) : []">
                            <div v-if="index < 4" :key="index" :style="{}">
                              <v-divider v-if="index !== 0" />
                              <v-list-item
                                v-if="index < 3 && item.type_id === 'job'"
                                class="truncate-text"
                                :style="{
                                  color: 'black !important',
                                  fontSize: '.8rem',
                                  minHeight: '36px !important',
                                  lineHeight: '36px',
                                }"
                              >
                              <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-briefcase-outline</v-icon>
                                <span style="font-weight: bold">
                                {{
                                  item && item.code
                                    ? `${item.code}`
                                    : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'Pickup Request'
                                    : ''
                                }}
                                </span>
                                -
                                {{
                                  item && item.name
                                    ? item.name
                                    : item.project && item.project.name
                                    ? item.project.name
                                    : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'ID: ' + request.id
                                    : ''
                                }}
                                <span style="color: #1976d2">
                                {{
                                  item && item.reference
                                    ? `; ${item.reference}`
                                    : ''
                                }}
                                </span>
                              </v-list-item>
                              <v-list-item
                                v-else-if="index < 3 && item.type_id === 'project'"
                                class="truncate-text"
                                :style="{
                                  color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                                  fontSize: '.8rem',
                                  minHeight: '36px !important',
                                  fontWeight: 'bold',
                                  lineHeight: '36px',
                                }"
                              >
                              <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-ruler</v-icon>
                                {{
                                    event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'Pickup Request - '
                                    : ''
                                }}
                                {{
                                  item && item.name
                                    ? item.name
                                    : ''
                                }}
                              </v-list-item>
                            </div>
                          </template>
                        </v-list>
                        <v-list 
                          v-if="showMoreText(event)"
                          class="pa-0"
                            :style="{
                              backgroundColor: 'transparent',
                              }"
                        >
                          <v-list-item
                            :style="{
                              color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                              fontSize: 'clamp(0.7rem, 1.2vw, 1rem)',
                              justifyContent: 'flex-end',
                            }"
                          >
                            {{ showMoreText(event) }}
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-calendar>
              </div>
            </v-card>
          </v-col>
        </v-row>
    </div>

    <!-- Role 32: Tabs for data table and calendar -->
    <div v-else-if="isDeliveriesRequester">
      <v-row>
        <v-col cols="auto" class="pb-0">
          <v-tabs v-model="selectedTab">
            <v-tabs v-model="selectedTab">
              <v-tab v-for="(tab, index) in tabs" :key="index">
                {{ tab }}
              </v-tab>
            </v-tabs>
          </v-tabs>
        </v-col>
      </v-row>
      <!-- <v-container class="mt-3" fluid> -->
        <v-row v-if="selectedTab == 0">
          <v-col>
            <v-row>
              <v-col cols="2" class="pb-0">
                <v-select
                  v-model="filterRequestType"
                  label="Type"
                  :items="requestTypes"
                  item-text="name"
                  item-value="id"
                  dense
                  hide-details
                  :loading="requestTypesLoading"
                  clearable
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                  <!-- eslint-disable-next-line vue/no-template-shadow -->
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="2" class="pb-0">
                <v-select
                  v-model="filterRequestShift"
                  label="Shift"
                  :items="requestShifts"
                  item-text="name"
                  item-value="id"
                  dense
                  hide-details
                  :loading="requestShiftsLoading"
                  clearable
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                  <!-- eslint-disable-next-line vue/no-template-shadow -->
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="2" class="pb-0">
                <v-select
                  v-model="filterRequestStatus"
                  label="Status"
                  :items="requestStatuses"
                  item-text="name"
                  item-value="id"
                  dense
                  hide-details
                  :loading="requestStatusesLoading"
                  multiple
                  clearable
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                  <!-- eslint-disable-next-line vue/no-template-shadow -->
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer;"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="auto" class="pb-0">
                <v-switch
                  class="mt-0"
                  v-model="activeArchivedTab"
                  label="Archived"
                />
              </v-col>
              <v-spacer />
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  outlined
                  @click="openTruckRequestForm(null)"
                >
                  <v-icon small class="mr-1">fas fa-plus</v-icon>
                  Delivery Request
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-0">
                <v-card elevation="0" outlined>
                  <v-data-table
                    :headers="headers"
                    :items="truckRequests"
                    :footer-props="footer"
                    :items-per-page="pagination.itemsPerPage"
                    :search="search"
                    :loading="loadingTruckRequests"
                    :height="windowHeight"
                    dense
                    fixed-header
                    :server-items-length="total"
                    @update:options="updateOptions"
                  >
                    <template #item="{ item }">
                      <tr :ref="`row-${item.id}`" :key="item.id">
                        <td class="text-center">
                          <template v-if="item.inventory_classes && item.inventory_classes.length > 1">
                            <v-tooltip top color="black">
                              <template #activator="{ on }">
                                <span style="color: #1976d2" v-on="on"
                                  >CLASSES</span
                                >
                              </template>
                              <v-row>
                                <v-col class="text-center pt-6 pb-6">
                                  <v-row
                                    v-for="class_item in item.inventory_classes"
                                    :key="class_item.id"
                                  >
                                    <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                      <v-chip
                                        class="mt-1 mb-1"
                                        small
                                        text-color="white"
                                        style="cursor: pointer"
                                        :color="
                                          class_item ? class_item.color : 'white'
                                        "
                                      >
                                        {{ class_item ? class_item.name : '' }}
                                      </v-chip>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-tooltip>
                          </template>
                          <v-chip
                            v-else-if="item.inventory_classes && item.inventory_classes.length === 1"
                            class="mt-1 mb-1"
                            small
                            text-color="white"
                            style="cursor: pointer"
                            :color="
                              item.inventory_classes[0]
                                ? item.inventory_classes[0].color
                                : 'white'
                            "
                          >
                            {{
                              item.inventory_classes[0] ? item.inventory_classes[0].name : ''
                            }}
                          </v-chip>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td>{{ item.id }}</td>
                        <td class="text-center">
                          <v-chip
                            v-if="item.request_type"
                            small
                            :style="{
                              background:
                                item && item.request_type ? item.request_type.color : 'grey',
                            }"
                            text-color="white"
                          >
                            {{ item && item.request_type ? item.request_type.name : '' }}
                          </v-chip>
                        </td>
                        <td>
                          <template
                            v-if="item.projects && item.projects.length > 1"
                          >
                            <v-tooltip top color="black">
                              <template #activator="{ on }">
                                <span style="color: #1976d2" v-on="on"
                                  >PROJECTS</span
                                >
                              </template>
                              <v-row>
                                <v-col class="text-center pt-6 pb-6">
                                  <v-row
                                    v-for="project_item in item.projects"
                                    :key="project_item.id"
                                  >
                                    <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                      {{ project_item ? project_item.name : '' }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-tooltip>
                          </template>
                          <span
                            v-else-if="item.projects && item.projects.length === 1"
                          >
                            {{
                              item.projects[0] ? item.projects[0].name : ''
                            }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td>
                          <template
                            v-if="item.jobs && item.jobs.length > 1"
                          >
                            <v-tooltip top color="black">
                              <template #activator="{ on }">
                                <span style="color: #1976d2" v-on="on"
                                  >JOBS</span
                                >
                              </template>
                              <v-row>
                                <v-col class="text-center pt-6 pb-6">
                                  <v-row
                                    v-for="job_item in item.jobs"
                                    :key="job_item.id"
                                  >
                                    <v-col cols="auto" class="pr-1 pb-1 pt-1">
                                      <span style="font-weight: bold">
                                        <text-highlight :queries="search">{{
                                          job_item.code ? `${job_item.code}` : ''
                                        }}</text-highlight>
                                      </span>
                                      <text-highlight :queries="search">
                                        -
                                        {{
                                          job_item.project &&
                                          job_item.project.name
                                            ? job_item.project.name
                                            : job_item.job &&
                                              job_item.job.name
                                            ? job_item.job.name
                                            : ''
                                        }}</text-highlight
                                      >
                                      <span style="color: #1976d2">
                                        <text-highlight :queries="search">{{
                                          job_item.reference ? `; ${job_item.reference}` : ''
                                        }}</text-highlight>
                                      </span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-tooltip>
                          </template>
                          <template
                            v-else-if="item.jobs && item.jobs.length === 1"
                          >
                            <span style="font-weight: bold">
                              <text-highlight :queries="search">{{
                                item.jobs[0].code ? `${item.jobs[0].code}` : ''
                              }}</text-highlight>
                            </span>
                            <text-highlight :queries="search">
                              -
                              {{
                                item.jobs[0].project &&
                                item.jobs[0].project.name
                                  ? item.jobs[0].project.name
                                  : item.jobs[0].job &&
                                    item.jobs[0].job.name
                                  ? item.jobs[0].job.name
                                  : ''
                              }}</text-highlight
                            >
                            <span style="color: #1976d2">
                              <text-highlight :queries="search">{{
                                item.jobs[0].reference ? `; ${item.jobs[0].reference}` : ''
                              }}</text-highlight>
                            </span>
                          </template>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td class="text-center">
                          <v-chip
                            v-if="item.truck_type"
                            class="mt-1 mb-1"
                            small
                            text-color="white"
                            style="cursor: pointer"
                            :color="
                              item.truck_type
                                ? item.truck_type.color
                                : 'white'
                            "
                          >
                            {{
                              item.truck_type ? item.truck_type.name : ''
                            }}
                          </v-chip>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td class="text-center">
                          <v-chip
                            v-if="item.truck"
                            class="mt-1 mb-1"
                            small
                            text-color="white"
                            style="cursor: pointer"
                            :color="
                              item.truck
                                ? item.truck.color
                                : 'white'
                            "
                          >
                            <text-highlight :queries="search">
                              {{ item.truck ? item.truck.name : '' }}
                            </text-highlight>
                          </v-chip>
                          <span v-else>
                            -
                          </span>
                        </td>
                        <td>
                          <text-highlight :queries="search">
                            {{ item && item.date ? item.date : '-' }}
                          </text-highlight>
                        </td>
                        <td>
                          <text-highlight :queries="search">
                            {{ item && item.slot ? item.slot.date : '-' }}
                          </text-highlight>
                        </td>
                        <td>
                          <text-highlight :queries="search">
                            {{
                              item && item.created_by_user_full_name
                                ? item.created_by_user_full_name
                                : '-'
                            }}
                          </text-highlight>
                        </td>
                        <td class="text-center">
                          <v-chip
                            small
                            :style="{
                              background:
                                item && item.request_shift ? item.request_shift.color : 'grey',
                            }"
                            text-color="white"
                          >
                            <text-highlight :queries="search">
                              {{ item && item.request_shift ? item.request_shift.name : '' }}
                            </text-highlight>
                          </v-chip>
                        </td>
                        <td class="text-center">
                          <!-- <template v-if="item.status_id === truckScheduleStatusIdShipped">
                            <v-tooltip top>
                              <template #activator="{ on, attrs }">
                                <v-chip
                                  v-on="on"
                                  v-attrs="attrs"
                                  small
                                  :style="{
                                    background:
                                      item && item.status ? item.status.color : 'grey',
                                  }"
                                  text-color="white"
                                >
                                  <text-highlight :queries="search">
                                    {{ item && item.status ? item.status.name : '' }}
                                  </text-highlight>
                                </v-chip>
                              </template>
                              <span>
                                {{ `${item.current_shipped_finished_goods_count}/${item.total_finished_goods_count}` }}
                              </span>
                            </v-tooltip>
                          </template> -->
                          <template>
                            <v-chip
                              small
                              :style="{
                                background:
                                  item && item.status ? item.status.color : 'grey',
                              }"
                              text-color="white"
                            >
                              <text-highlight :queries="search">
                                {{ item && item.status ? item.status.name : '' }}
                              </text-highlight>
                            </v-chip>
                          </template>
                        </td>
                        <td class="text-right">
                          <v-btn
                            v-if="item.bill_of_ladings.length > 0"
                            class="ml-1 mt-1 mb-1"
                            color="success"
                            outlined
                            small
                            @click="openBillOfLadingList(item)"
                          >
                            BOL
                          </v-btn>
                          <v-btn
                            class="ml-1 mt-1 mb-1"
                            color="primary"
                            outlined
                            small
                            @click="openTruckRequestForm(item, true)"
                          >
                            VIEW
                          </v-btn>
                          <v-menu
                            v-if="
                              belongsToRequester(item) &&
                              !truckRequestHasBillOfLadings(item)
                            "
                            offset-y
                          >
                            <template #activator="{ on, attrs }">
                              <v-btn
                                class="ml-1 mt-1 mb-1"
                                elevation="0"
                                fab
                                outlined
                                x-small
                                v-bind="attrs"
                                tile
                                color="primary"
                                style="
                                  border-radius: 7px;
                                  width: 28px !important;
                                  height: 28px !important;
                                "
                                v-on="on"
                              >
                                <v-icon> mdi-dots-vertical </v-icon>
                              </v-btn>
                            </template>
                            <v-list class="pa-3">
                              <v-list-item
                                v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && !truckRequestIsCanceled(item) && !isTruckRequestArchived(item)"
                                :disabled="isTruckRequestEditDisabled(item)"
                                @click="openTruckRequestForm(item)">
                                <v-list-item-title
                                  :style="`color: ${isTruckRequestEditDisabled(item) ? 'rgba(0, 0, 0, 0.38)' : 'green'}; font-weight: 600;`"
                                >
                                  <v-row align="center">
                                    <v-col
                                      cols="auto"
                                      class="pr-0"
                                      style="white-space: nowrap"
                                    />
                                    <v-col class="pt-4"> EDIT </v-col>
                                  </v-row>
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                v-if="!truckRequestHasBillOfLadings(item) && !truckRequestIsComplete(item) && truckRequestIsScheduled(item) && !truckRequestIsCanceled(item)"
                                @click="cancelTruckRequest(item)"
                              >
                                <v-list-item-title
                                  :style="`color: red; font-weight: 600;`"
                                >
                                  <v-row align="center">
                                    <v-col
                                      cols="auto"
                                      class="pr-0"
                                      style="white-space: nowrap"
                                    />
                                    <v-col class="pt-4"> CANCEL </v-col>
                                  </v-row>
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                v-if="!truckRequestHasBillOfLadings(item) && !truckRequestHasSuppliedPickList(item) && !truckRequestIsComplete(item) && truckRequestIsNotAssigned(item)"
                                @click="softDeleteTruckRequest(item)"
                              >
                                <v-list-item-title
                                  :style="`color: red; font-weight: 600;`"
                                >
                                  <v-row align="center">
                                    <v-col
                                      cols="auto"
                                      class="pr-0"
                                      style="white-space: nowrap"
                                    />
                                    <v-col class="pt-4"> DELETE </v-col>
                                  </v-row>
                                </v-list-item-title>
                              </v-list-item>
                              <!-- <v-list-item
                                @click="softDeleteTruckRequest(item.id)"
                              >
                                <v-list-item-title
                                  :style="`color: red; font-weight: 600;`"
                                >
                                  <v-row align="center">
                                    <v-col
                                      cols="auto"
                                      class="pr-0"
                                      style="white-space: nowrap"
                                    />
                                    <v-col class="pt-4"> DELETE </v-col>
                                  </v-row>
                                </v-list-item-title>
                              </v-list-item> -->
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="selectedTab == 1">
          <v-col>
            <v-row>
              <v-col cols="auto" class="pt-4">
                <v-toolbar-title v-if="$refs.calendar">
                  {{ $refs.calendar.title }}
                </v-toolbar-title>
              </v-col>
              <v-col cols="1">
                <v-select
                  v-model="calendarType"
                  :items="calendarTypes"
                  dense
                  hide-details
                  label="Type"
                  item-value="type"
                >
                  <template #item="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                  <!-- eslint-disable-next-line vue/no-template-shadow -->
                  <template #selection="{ item }">
                    <v-chip
                      class="mt-1 mb-1"
                      small
                      text-color="white"
                      style="cursor: pointer"
                      :color="item ? item.color : 'white'"
                    >
                      {{ item ? item.name : '' }}
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
              <v-col cols="auto">
                <v-switch
                  class="mt-0"
                  v-model="activeArchivedTab"
                  label="Archived"
                />
              </v-col>
              <v-spacer />
              <v-col cols="auto" class="pa-0">
                <v-btn fab icon color="grey darken-2" @click="prev">
                  <v-icon x-large> mdi-chevron-left </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="auto" class="pa-0">
                <v-btn fab icon color="grey darken-2" @click="next">
                  <v-icon x-large> mdi-chevron-right </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0 pb-0">
                <v-card elevation="0" outlined>
                  <div class="calendar-container">
                    <v-calendar
                      ref="calendar"
                      v-model="focusDay"
                      :weekdays="weekday"
                      :type="calendarType"
                      :event-more="false"
                      :events="events"
                      event-overlap-mode="column"
                      interval-count="0"
                      color="primary"
                      @change="onDateRangeChange"
                    >
                      <template #day-label-header="dayLabelHeader">
                        <!-- for week and day view  -->
                        <v-row>
                          <v-col
                            v-if="holidaysObj[dayLabelHeader.date]"
                            style="font-weight: bold"
                          >
                            {{ holidaysObj[dayLabelHeader.date] }}
                          </v-col>
                          <v-col v-else>
                            {{ dayLabelHeader.day }}
                          </v-col>
                        </v-row>
                        <div class="day-header-actions">
                          <!-- Right-aligned truck indicator -->
                          <div class="mr-6 d-flex align-center justify-end">
                            <v-progress-circular
                              v-if="loadingAvailableTrucksByDate"
                              indeterminate
                              :size="20"
                              :width="2"
                              class="v-progress-circular--visible"
                            />
                            
                            <v-tooltip
                              v-else-if="
                                availableTrucksByDate[dayLabelHeader.date] !== undefined &&
                                getTotalAvailableTrucksCount(dayLabelHeader.date) > 0"
                              top
                              color="black"
                            >
                              <template #activator="{ on }">
                                <div class="d-flex align-center" v-on="on">
                                  <v-icon medium>mdi-truck-outline</v-icon>
                                  <v-badge
                                    offset-x="6"
                                    offset-y="0"
                                    :content="getTotalAvailableTrucksCount(dayLabelHeader.date)"
                                    color="green"
                                  />
                                </div>
                              </template>

                              <div class="pa-2" style="min-width: 350px;">
                                <v-simple-table dark dense>
                                  <thead>
                                    <tr>
                                      <th class="text-left">Truck Type</th>
                                      <th class="text-center">Total</th>
                                      <th class="text-center">Unavailable</th>
                                      <th class="text-center">Pending</th>
                                      <th class="text-center">Available</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr
                                      v-for="item in availableTrucksByDate[dayLabelHeader.date]"
                                      :key="item.truck_type_id"
                                    >
                                      <td class="text-left">
                                        <v-chip
                                          small
                                          text-color="white"
                                          :color="item.truck_type ? item.truck_type.color : 'white'"
                                        >
                                          {{ item.truck_type ? item.truck_type.name : '' }}
                                        </v-chip>
                                      </td>

                                      <td class="text-center">
                                        {{ item.total_count || 0 }}
                                      </td>

                                      <td class="text-center">
                                        {{ item.unavailable_count || 0 }}
                                      </td>

                                      <td class="text-center">
                                        {{ item.pending_count || 0 }}
                                      </td>

                                      <td class="text-center">
                                        <strong>
                                          {{ item.available_count || item.count || 0 }}
                                        </strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </v-simple-table>
                              </div>
                            </v-tooltip>

                            <v-icon v-else>mdi-truck-remove-outline</v-icon>
                          </div>
                        </div>
                      </template>
                      <template #day-label="dayLabel">
                        <!-- for month view  -->
                        <v-row>
                          <v-col
                            v-if="holidaysObj[dayLabel.date]"
                            style="font-weight: bold"
                          >
                            {{ holidaysObj[dayLabel.date] }}
                          </v-col>
                          <v-col v-else>
                            {{ dayLabel.day }}
                          </v-col>
                        </v-row>
                      </template>
                      <!-- Slot for customizing events -->
                      <template #event="{ event, attrs }">
                        <v-card
                          class="calendar-event pr-1 pl-1"
                          :style="{ color: 'black', background: `${getEventBackgroundColor(event)}`, border: '1px solid #e0e0e0', borderLeft: `8px solid ${getEventBorderColor(event)}`, borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: `${getEventHeight(event)}px` }"
                          tile
                          :data-event-id="event.id"
                          @click="openScheduledDeliveryForm(event)"
                          v-bind="attrs"
                        >
                          <v-card-title class="pa-1">
                            <v-row class="px-0" justify="center" align="center">
                              <v-col class="px-2" cols="auto">
                                <v-chip
                                  label
                                  small
                                  :color="
                                    event && event.status ? lightenColor(event.status.color) : ''
                                  "
                                  :style="{fontWeight: 'bold'}"
                                  :text-color="event && event.status ? event.status.color : ''"
                                >
                                  {{
                                    event && event.status ? event.status.name : ''
                                  }}
                                </v-chip>
                              </v-col>
                              <v-col :class="'truncate-text pr-2 pl-0'">
                                <span :style="{ fontSize: '.8rem' }">
                                  {{ event.name }}
                                  <span v-if="isScheduledDeliveryPending(event)" style="color:#1976D2;">
                                    PENDING
                                  </span>
                                </span>
                              </v-col>
                              <v-col cols="auto">
                                <template v-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length > 1">
                                  <v-tooltip top color="black">
                                    <template #activator="{ on }">
                                      <span :style="{ fontSize: '.8rem !important', color: '#1976d2' }" v-on="on">
                                        CLASSES
                                      </span>
                                    </template>
                                    <v-row>
                                      <v-col class="text-center pt-6 pb-6">
                                        <v-row
                                          v-for="class_item in event.request.inventory_classes"
                                          :key="class_item.id"
                                        >
                                          <v-col cols="auto" class="pb-1 pt-1">
                                            <v-chip
                                              class="mt-1 mb-1"
                                              small
                                              text-color="white"
                                              style="cursor: pointer"
                                              :color="
                                                class_item ? class_item.color : 'white'
                                              "
                                            >
                                              {{ class_item ? class_item.name : '' }}
                                            </v-chip>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                  </v-tooltip>
                                </template>
                                <v-chip
                                  v-else-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length === 1"
                                  class="mt-1 mb-1"
                                  small
                                  text-color="white"
                                  style="cursor: pointer"
                                  :color="
                                    event.request.inventory_classes[0]
                                      ? event.request.inventory_classes[0].color
                                      : 'white'
                                  "
                                >
                                  {{
                                    event.request.inventory_classes[0] ? event.request.inventory_classes[0].name : ''
                                  }}
                                </v-chip>
                                <span v-else>
                                  -
                                </span>
                              </v-col>
                            </v-row>
                          </v-card-title>
                          <v-card-text>
                            <v-list
                              class="pa-0"
                              :style="{
                                backgroundColor: 'transparent',
                                }"
                            >
                              <template v-for="(item, index) in event && event.request ? mapJobsAndProjectsToListItem(event.request) : []">
                                <div v-if="index < 4" :key="index" :style="{}">
                                  <v-divider v-if="index !== 0" />
                                  <v-list-item
                                    v-if="index < 3 && item.type_id === 'job'"
                                    class="truncate-text"
                                    :style="{
                                      color: 'black !important',
                                      fontSize: '.8rem',
                                      minHeight: '36px !important',
                                      lineHeight: '36px',
                                    }"
                                  >
                                  <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-briefcase-outline</v-icon>
                                    <span style="font-weight: bold">
                                    {{
                                      item && item.code
                                        ? `${item.code}`
                                        : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                        ? 'Pickup Request'
                                        : ''
                                    }}
                                    </span>
                                    -
                                    {{
                                      item && item.name
                                        ? item.name
                                        : item.project && item.project.name
                                        ? item.project.name
                                        : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                        ? 'ID: ' + request.id
                                        : ''
                                    }}
                                    <span style="color: #1976d2">
                                    {{
                                      item && item.reference
                                        ? `; ${item.reference}`
                                        : ''
                                    }}
                                    </span>
                                  </v-list-item>
                                  <v-list-item
                                    v-else-if="index < 3 && item.type_id === 'project'"
                                    class="truncate-text"
                                    :style="{
                                      color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                                      fontSize: '.8rem',
                                      minHeight: '36px !important',
                                      fontWeight: 'bold',
                                      lineHeight: '36px',
                                    }"
                                  >
                                  <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-ruler</v-icon>
                                    {{
                                        event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                        ? 'Pickup Request - '
                                        : ''
                                    }}
                                    {{
                                      item && item.name
                                        ? item.name
                                        : ''
                                    }}
                                  </v-list-item>
                                </div>
                              </template>
                            </v-list>
                            <v-list 
                              v-if="showMoreText(event)"
                              class="pa-0"
                                :style="{
                                  backgroundColor: 'transparent',
                                  }"
                            >
                              <v-list-item
                                :style="{
                                  color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                                  fontSize: 'clamp(0.7rem, 1.2vw, 1rem)',
                                  justifyContent: 'flex-end',
                                }"
                              >
                                {{ showMoreText(event) }}
                              </v-list-item>
                            </v-list>
                          </v-card-text>
                        </v-card>
                      </template>
                    </v-calendar>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      <!-- </v-container> -->
    </div>

    <!-- Role 33: Only v-calendar -->
    <div v-else-if="isDeliveriesView">
      <!-- <v-container class="mt-3" fluid> -->
        <v-row>
          <v-col>
            <v-card elevation="0" outlined>
              <v-card-title>
                <v-row>
                  <v-col cols="auto" class="pt-4">
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title }}
                    </v-toolbar-title>
                  </v-col>
                  <v-col cols="1">
                    <v-select
                      v-model="calendarType"
                      :items="calendarTypes"
                      dense
                      hide-details
                      label="Type"
                      item-value="type"
                    >
                      <template #item="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                      <!-- eslint-disable-next-line vue/no-template-shadow -->
                      <template #selection="{ item }">
                        <v-chip
                          class="mt-1 mb-1"
                          small
                          text-color="white"
                          style="cursor: pointer"
                          :color="item ? item.color : 'white'"
                        >
                          {{ item ? item.name : '' }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="auto" class="pb-0">
                    <v-switch
                      class="mt-0"
                      v-model="activeArchivedTab"
                      label="Archived"
                    />
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto" class="pa-0">
                    <v-btn fab icon color="grey darken-2" @click="prev">
                      <v-icon x-large> mdi-chevron-left </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" class="pa-0">
                    <v-btn fab icon color="grey darken-2" @click="next">
                      <v-icon x-large> mdi-chevron-right </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
              <div class="calendar-container">
                <v-calendar
                  ref="calendar"
                  v-model="focusDay"
                  :weekdays="weekday"
                  :type="calendarType"
                  :event-more="false"
                  :events="events"
                  event-overlap-mode="column"
                  interval-count="0"
                  color="primary"
                  @change="onDateRangeChange"
                >
                  <template #day-label-header="dayLabelHeader">
                    <!-- for week and day view  -->
                    <v-row>
                      <v-col
                        v-if="holidaysObj[dayLabelHeader.date]"
                        style="font-weight: bold"
                      >
                        {{ holidaysObj[dayLabelHeader.date] }}
                      </v-col>
                      <v-col v-else>
                        {{ dayLabelHeader.day }}
                      </v-col>
                    </v-row>
                    <div class="day-header-actions">
                      <!-- Right-aligned truck indicator -->
                      <div class="mr-6 d-flex align-center justify-end">
                        <v-progress-circular
                          v-if="loadingAvailableTrucksByDate"
                          indeterminate
                          :size="20"
                          :width="2"
                          class="v-progress-circular--visible"
                        />
                        
                        <v-tooltip
                          v-else-if="
                            availableTrucksByDate[dayLabelHeader.date] !== undefined &&
                            getTotalAvailableTrucksCount(dayLabelHeader.date) > 0"
                          top
                          color="black"
                        >
                          <template #activator="{ on }">
                            <div class="d-flex align-center" v-on="on">
                              <v-icon medium>mdi-truck-outline</v-icon>
                              <v-badge
                                offset-x="6"
                                offset-y="0"
                                :content="getTotalAvailableTrucksCount(dayLabelHeader.date)"
                                color="green"
                              />
                            </div>
                          </template>

                          <div class="pa-2" style="min-width: 350px;">
                            <v-simple-table dark dense>
                              <thead>
                                <tr>
                                  <th class="text-left">Truck Type</th>
                                  <th class="text-center">Total</th>
                                  <th class="text-center">Unavailable</th>
                                  <th class="text-center">Pending</th>
                                  <th class="text-center">Available</th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr
                                  v-for="item in availableTrucksByDate[dayLabelHeader.date]"
                                  :key="item.truck_type_id"
                                >
                                  <td class="text-left">
                                    <v-chip
                                      small
                                      text-color="white"
                                      :color="item.truck_type ? item.truck_type.color : 'white'"
                                    >
                                      {{ item.truck_type ? item.truck_type.name : '' }}
                                    </v-chip>
                                  </td>

                                  <td class="text-center">
                                    {{ item.total_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    {{ item.unavailable_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    {{ item.pending_count || 0 }}
                                  </td>

                                  <td class="text-center">
                                    <strong>
                                      {{ item.available_count || item.count || 0 }}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </v-simple-table>
                          </div>
                        </v-tooltip>

                        <v-icon v-else>mdi-truck-remove-outline</v-icon>
                      </div>
                    </div>
                  </template>
                  <template #day-label="dayLabel">
                    <!-- for month view  -->
                    <v-row>
                      <v-col
                        v-if="holidaysObj[dayLabel.date]"
                        style="font-weight: bold"
                      >
                        {{ holidaysObj[dayLabel.date] }}
                      </v-col>
                      <v-col v-else>
                        {{ dayLabel.day }}
                      </v-col>
                    </v-row>
                  </template>
                  <!-- Slot for customizing events -->
                  <template #event="{ event, attrs }">
                    <v-card
                      class="calendar-event pr-1 pl-1"
                      :style="{ color: 'black', background: `${getEventBackgroundColor(event)}`, border: '1px solid #e0e0e0', borderLeft: `8px solid ${getEventBorderColor(event)}`, borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: `${getEventHeight(event)}px` }"
                      tile
                      :data-event-id="event.id"
                      @click="openScheduledDeliveryForm(event)"
                      v-bind="attrs"
                    >
                      <v-card-title class="pa-1">
                        <v-row class="px-0" justify="center" align="center">
                          <v-col class="px-2" cols="auto">
                            <v-chip
                              label
                              small
                              :color="
                                event && event.status ? lightenColor(event.status.color) : ''
                              "
                              :style="{fontWeight: 'bold'}"
                              :text-color="event && event.status ? event.status.color : ''"
                            >
                              {{
                                event && event.status ? event.status.name : ''
                              }}
                            </v-chip>
                          </v-col>
                          <v-col :class="'truncate-text pr-2 pl-0'">
                            <span :style="{ fontSize: '.8rem' }">
                              {{ event.name }}
                              <span v-if="isScheduledDeliveryPending(event)" style="color:#1976D2;">
                                PENDING
                              </span>
                            </span>
                          </v-col>
                          <v-col cols="auto">
                            <template v-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length > 1">
                              <v-tooltip top color="black">
                                <template #activator="{ on }">
                                  <span :style="{ fontSize: '.8rem !important', color: '#1976d2' }" v-on="on">
                                    CLASSES
                                  </span>
                                </template>
                                <v-row>
                                  <v-col class="text-center pt-6 pb-6">
                                    <v-row
                                      v-for="class_item in event.request.inventory_classes"
                                      :key="class_item.id"
                                    >
                                      <v-col cols="auto" class="pb-1 pt-1">
                                        <v-chip
                                          class="mt-1 mb-1"
                                          small
                                          text-color="white"
                                          style="cursor: pointer"
                                          :color="
                                            class_item ? class_item.color : 'white'
                                          "
                                        >
                                          {{ class_item ? class_item.name : '' }}
                                        </v-chip>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-tooltip>
                            </template>
                            <v-chip
                              v-else-if="event.request && event.request.inventory_classes && event.request.inventory_classes.length === 1"
                              class="mt-1 mb-1"
                              small
                              text-color="white"
                              style="cursor: pointer"
                              :color="
                                event.request.inventory_classes[0]
                                  ? event.request.inventory_classes[0].color
                                  : 'white'
                              "
                            >
                              {{
                                event.request.inventory_classes[0] ? event.request.inventory_classes[0].name : ''
                              }}
                            </v-chip>
                            <span v-else>
                              -
                            </span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-card-text>
                      <v-list
                          class="pa-0"
                          :style="{
                            backgroundColor: 'transparent',
                            }"
                        >
                          <template v-for="(item, index) in event && event.request ? mapJobsAndProjectsToListItem(event.request) : []">
                            <div v-if="index < 4" :key="index" :style="{}">
                              <v-divider v-if="index !== 0" />
                              <v-list-item
                                v-if="index < 3 && item.type_id === 'job'"
                                class="truncate-text"
                                :style="{
                                  color: 'black !important',
                                  fontSize: '.8rem',
                                  minHeight: '36px !important',
                                  lineHeight: '36px',
                                }"
                              >
                              <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-briefcase-outline</v-icon>
                                <span style="font-weight: bold">
                                {{
                                  item && item.code
                                    ? `${item.code}`
                                    : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'Pickup Request'
                                    : ''
                                }}
                                </span>
                                -
                                {{
                                  item && item.name
                                    ? item.name
                                    : item.project && item.project.name
                                    ? item.project.name
                                    : event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'ID: ' + request.id
                                    : ''
                                }}
                                <span style="color: #1976d2">
                                {{
                                  item && item.reference
                                    ? `; ${item.reference}`
                                    : ''
                                }}
                                </span>
                              </v-list-item>
                              <v-list-item
                                v-else-if="index < 3 && item.type_id === 'project'"
                                class="truncate-text"
                                :style="{
                                  color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                                  fontSize: '.8rem',
                                  minHeight: '36px !important',
                                  fontWeight: 'bold',
                                  lineHeight: '36px',
                                }"
                              >
                              <v-icon :style="{ fontSize: '.8rem' }" class="mr-1">mdi-ruler</v-icon>
                                {{
                                    event.request.request_type_id === truckScheduleRequestTypeIdPickup
                                    ? 'Pickup Request - '
                                    : ''
                                }}
                                {{
                                  item && item.name
                                    ? item.name
                                    : ''
                                }}
                              </v-list-item>
                            </div>
                          </template>
                        </v-list>
                        <v-list 
                          v-if="showMoreText(event)"
                          class="pa-0"
                            :style="{
                              backgroundColor: 'transparent',
                              }"
                        >
                          <v-list-item
                            :style="{
                              color: `${isScheduledDeliveryPending(event) ? 'white' : 'black'} !important`,
                              fontSize: 'clamp(0.7rem, 1.2vw, 1rem)',
                              justifyContent: 'flex-end',
                            }"
                          >
                            {{ showMoreText(event) }}
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-calendar>
              </div>
            </v-card>
          </v-col>
        </v-row>
      <!-- </v-container> -->
    </div>
    <truck-schedule-request-form
      ref="truckScheduleRequestForm"
      @success="success"
    />
    <truck-schedule-delivery-form
      ref="truckScheduledDeliveryForm"
      @success="success"
    />
    <truck-schedule-manual-schedule-form
      ref="truckScheduleManualScheduleForm"
      @success="manualScheduleSuccess"
    />
    <truck-schedule-bill-of-lading-list-form ref="billOfLadingList" />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import TruckScheduleRequestForm from '@/components/forms/truckSchedules/TruckScheduleRequestForm';
import TruckScheduleDeliveryForm from '@/components/forms/truckSchedules/TruckScheduleDeliveryForm';
import TruckScheduleManualScheduleForm from '@/components/forms/truckSchedules/TruckScheduleManualScheduleForm';
import TruckScheduleBillOfLadingListForm from '@/components/forms/truckSchedules/TruckScheduleBillOfLadingListForm';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {
    TruckScheduleRequestForm,
    TruckScheduleDeliveryForm,
    TruckScheduleManualScheduleForm,
    TruckScheduleBillOfLadingListForm,
  },
  data: () => ({
    roles: [],
    truckRequest: null,
    truckRequests: [],
    scheduledDeliveries: [],
    availableTrucksByDate: {},
    footer: {
      'items-per-page-options': [10, 50, 100, 500, 1000, -1],
    },
    rowsPerPageItems: [10, 50, 100, 500, 1000],
    loadingTruckRequests: false,
    loadingScheduledDeliveries: false,
    loadingAvailableTrucksByDate: false,
    topSpaceHeight: 250,
    windowHeight: 1000,
    windowHalfHeight: 1000,
    pagination: {
      itemsPerPage: 50,
      page: 1,
    },
    sort: {
      order_by_first: 'id',
      direction_sort: true,
    },

    calendarType: 'week',
    calendarTypes: [
      { type: 'month', name: 'MONTH', color: '#388E3C' },
      { type: 'week', name: 'WEEK', color: '#B71C1C' },
      { type: 'day', name: 'DAY', color: '#FBC02D' },
    ],
    weekday: [1, 2, 3, 4, 5, 6],
    focusDay: '',
    start: null,
    end: null,
    webhookDates: [],

    total: 0,
    totalRecords: 0,
    activeArchivedTab: 0,
    selectedTab: 0,
    table: 'truckScheduleRequestTable',
    inventoryClassId: null,

    userRoleIdAdmin: 3,
    userRoleIdDeliveriesManager: 31,
    userRoleIdDeliveriesRequester: 32,
    userRoleIdDeliveriesView: 33,
    truckScheduleRequestShiftIdPending: 1,
    truckScheduleRequestTypeIdPickup: 1,

    truckScheduleStatusIdRequested: 1,
    truckScheduleStatusIdScheduled: 2,
    truckScheduleStatusIdInProgress: 3,
    truckScheduleStatusIdShipped: 5,
    truckScheduleStatusIdComplete: 8,
    truckScheduleStatusIdCanceled: 10,
    truckScheduleStatusIdPendingApproval: 11,
    truckScheduleStatusIdPendingScheduling: 12,

    truckScheduleRequestTypeIdPickup: 1,
    truckScheduleRequestTypeIdNonWindowDelivery: 3,

    pickListStatusIdPartiallySupplied: 2,
    pickListStatusIdSupplied: 3,
    pickListStatusIdShipped: 4,

    scheduledDeliveryCardPendingColor: '#0277BD',

    filterRequestType: null,
    filterRequestShift: null,
    filterRequestStatus: null,

    requestTypesLoading: false,
    requestShiftsLoading: false,
    requestStatusesLoading: false,

    roles: [],
    holidays: [],
    holidaysObj: {},
    requestTypes: [],
    requestShifts: [],
    requestStatuses: [],

    manualScheduleDate: null,

    isDraggingOverDate: null,
    isAddEventDisabled: true,
    manualSchedule: false,

    tabs: ['Delivery Requests', 'Scheduled Deliveries'],
    selectedTab: 0,
  }),
  computed: {
    jobLabel() {
      return this.$store.getters['businessRulesGetBoolean']('Jobs Rename to Release')
        ? 'Release'
        : 'Job'; 
    },
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
    }),
    isAdmin() {
      return this.roles.includes(this.userRoleIdAdmin);
    },
    isDeliveriesManager() {
      return this.roles.includes(this.userRoleIdDeliveriesManager);
    },
    isDeliveriesRequester() {
      return this.roles.includes(this.userRoleIdDeliveriesRequester);
    },
    isDeliveriesView() {
      return this.roles.includes(this.userRoleIdDeliveriesView);
    },
    currentDate() {
      return moment(new Date().toLocaleDateString('en-US')).format(
        'YYYY-MM-DD'
      );
    },
    headers() {
      const headers = [];

      if (this.isDeliveriesManager || this.isAdmin) {
        headers.push({
          text: '',
          value: 'draggable',
          width: '1%',
          sortable: false,
        });
      }
      headers.push({
        text: 'Class',
        value: 'inventory_classes',
        width: '3%',
        align: 'center',
      });
      headers.push({
        text: 'ID',
        value: 'id',
        width: '3%',
        align: 'center',
      });
      headers.push({ text: 'Type', value: 'request_type', width: '5%', align: 'center' });
      headers.push({ text: 'Project', value: 'projects', width: '10%' });
      headers.push({ text: 'WO#', value: 'jobs', width: '15%' });
      headers.push({
        text: 'Truck Types',
        value: 'truck_type',
        width: '5%',
        align: 'center',
        sortable: false,
      });
      headers.push({
        text: 'Trucks',
        value: 'truck',
        width: '5%',
        align: 'center',
        sortable: false,
      });
      headers.push({
        text: 'Requested Delivery Date',
        value: 'date',
        width: '10%',
      });
      headers.push({
        text: 'Scheduled Delivery Date',
        value: 'slot',
        width: '10%',
      });
      headers.push({
        text: 'Requested By',
        value: 'created_by_full_name',
        width: '5%',
      });
      // headers.push({
      //   text: 'Scheduled Deliveries ID',
      //   value: 'slot_id',
      //   width: '7%',
      // });
      headers.push({
        text: 'Shift',
        value: 'shift.name',
        width: '5%',
        align: 'center',
      });
      headers.push({
        text: 'Status',
        value: 'status.name',
        width: '10%',
        align: 'center',
      });
      headers.push({
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '15%',
        sortable: false,
      });

      return headers;
    },
    events() {
      const scheduledEvents = [];
      const pendingEvents = [];
      const pickupEvents = [];
      this.scheduledDeliveries.forEach((scheduledDelivery) => {
        if (this.isScheduledDeliveryPending(scheduledDelivery)) {
          const pendingScheduledDeliveryEvent = {
            ...scheduledDelivery,
            start: scheduledDelivery.date,
            end: scheduledDelivery.date,
            name: scheduledDelivery.title,
          }
          pendingEvents.push(pendingScheduledDeliveryEvent);
        }
        else if (this.isScheduledDeliveryPickup(scheduledDelivery)) {
          const pickupScheduledDeliveryEvent = {
            ...scheduledDelivery,
            start: scheduledDelivery.date,
            end: scheduledDelivery.date,
            name: scheduledDelivery.title,
          }
          pickupEvents.push(pickupScheduledDeliveryEvent);
        }
        else {
          const scheduledDeliveryEvent = {
            ...scheduledDelivery,
            start: scheduledDelivery.date,
            end: scheduledDelivery.date,
            name: scheduledDelivery.title,
          };
          scheduledEvents.push(scheduledDeliveryEvent);
        }
      });
      //add pending events to the front of the array so they display first in the v-calendar
      const events = [...pendingEvents, ...pickupEvents, ...scheduledEvents];
      return events;
    },
    dateRangeText: {
      get() {
        return this.webhookDates.join(' ~ ');
      },
      set(value) {
        if (value && value.length > 0) {
          // Split the value by ' ~ ' and assign to webhookDates
          console.log('Splitting value: ', value);
          this.webhookDates = value.split(' ~ ');
          return
        }
        this.webhookDates = [];
      }
    }
  },
  watch: {
    pagination() {
      this.getTruckRequests();
    },
    search() {
      this.getTruckRequests();
      this.getScheduledDeliveries({ start: this.start, end: this.end });
    },
    filterRequestType() {
      this.getTruckRequests();
    },
    filterRequestShift() {
      this.getTruckRequests();
    },
    filterRequestStatus() {
      this.getTruckRequests();
    },
    activeArchivedTab() {
      this.getTruckRequests();
      this.getScheduledDeliveries({ start: this.start, end: this.end });
    },
    inventoryClassId() {},
  },
  created() {
    this.roles = this.user.roles.map((x) => x.id);
    this.windowHalfHeight = (window.innerHeight - this.topSpaceHeight) / 2;
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.init();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      this.getTruckRequests();
      await this.getHolidays();
      this.setHolidaysObj();
      this.getRequestShifts();
      this.getRequestTypes();
      this.getRequestStatuses()
    },

    async getTruckRequests() {
      this.loadingTruckRequests = true;
      this.truckRequests = [];
      this.total = 0;
      const limitToCurrentUser = this.isDeliveriesRequester && !this.isDeliveriesManager && !this.isAdmin;
      const submitModel = {
        filters: {
          request_type_id: this.filterRequestType,
          request_shift_id: this.filterRequestShift,
          status_id: this.filterRequestStatus,
          is_archived: this.activeArchivedTab,
          created_by: limitToCurrentUser ? this.user.id : null,
        },
        // with: ['jobs_pick_lists'],
        pagination: this.pagination,
        sort: this.sort,
        search: this.search,
      };
      const res = await this.$api.truckScheduleRequest.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) {
        this.truckRequests = [];
        this.total = 0;
        return;
      }
      if (!res || !res.data) {
        this.loadingTruckRequests = false;
        this.$bus.$emit('showError', 'Unable to get truck requests');
        this.truckRequests = [];
        this.total = 0;
        return;
      }
      this.loadingTruckRequests = false;
      this.truckRequests = res.data;
      this.total = res.total;
    },

    async onDateRangeChange({start, end}) {
      if (!start || !end) return;
      this.start = start;
      this.end = end;
      this.getScheduledDeliveries({ start, end });
      this.getAvailableTrucksByDate({ start, end });
    },

    async getScheduledDeliveries({ start, end }) {
      if (!start || !end) return;
      this.loadingScheduledDeliveries = true;
      this.scheduledDeliveries = [];
      const submitModel = {
        filters: {
          start_date: start.date,
          end_date: end.date,
          is_archived: this.activeArchivedTab,
        },
        search: this.search,
        // with: ['request_pick_lists'],
      };
      const res = await this.$api.truckScheduleSlot.read(submitModel);
      const cancelCode = 3001;
      this.loadingScheduledDeliveries = false;
      if (res === cancelCode) {
        this.scheduledDeliveries = [];
        return;
      }
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get scheduled deliveries');
        this.scheduledDeliveries = [];
        return;
      }
      this.scheduledDeliveries = res;
    },

    async getAvailableTrucksByDate({ start, end }) {
      if (!start || !end) return;
      this.loadingAvailableTrucksByDate = true;
      this.availableTrucksByDate = {};
      const submitModel = {
        filters: {
          start_date: start.date,
          end_date: end.date,
        }
      };
      // const res = await this.$api.truckScheduleTruck.read(submitModel, null, 'read-available');
      const res = await this.$api.truckScheduleTruck.read(submitModel, null, 'read-available-truck-type-counts');
      const cancelCode = 3001;
      this.loadingAvailableTrucksByDate = false;
      if (res === cancelCode) {
        this.availableTrucksByDate = {};
        return;
      }
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get available truck count by date');
        this.availableTrucksByDate = {};
        return;
      }
      this.availableTrucksByDate = res;
    },

    async getRequestShifts() {
      this.requestShiftsLoading = true;
      const res = await this.$api.truckScheduleRequestShift.get();
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get request shifts');
        this.requestShiftsLoading = false;
        return;
      }
      this.requestShifts = res;
      this.requestShiftsLoading = false;
    },

    async getRequestTypes() {
      this.requestTypesLoading = true;
      const res = await this.$api.truckScheduleRequestType.get();
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get request types');
        this.requestTypesLoading = false;
        return;
      }
      this.requestTypes = res;
      this.requestTypesLoading = false;
    },

    async getRequestStatuses() {
      this.requestStatusesLoading = true;
      const res = await this.$api.truckScheduleStatus.get();
      if (!res) {
        this.$bus.$emit('showError', 'Unable to get request statuses');
        this.requestStatusesLoading = false;
        return;
      }
      this.requestStatuses = res;
      this.requestStatusesLoading = false;
    },

    async softDeleteTruckRequest(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this delivery request?',
      });
      if (!confirm) return;
      if (!item || !item.id) return;

      const res = await this.$api.truckScheduleRequest.delete(item.id);

      if (!res) {
        this.$bus.$emit('showError', 'Unable to delete delivery request');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.getScheduledDeliveries({ start: this.start, end: this.end });
      this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      this.getTruckRequests();
    },

    async cancelTruckRequest(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to cancel this delivery request?',
      });
      if (!confirm) return;
      if (!item || !item.id) return;

      const res = await this.$api.truckScheduleRequest.get(`cancel/${item.id}`);

      if (!res) {
        this.$bus.$emit('showError', 'Unable to cancel delivery request');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.getScheduledDeliveries({ start: this.start, end: this.end });
      this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      this.getTruckRequests();
    },

    async toggleArchive(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure that you want to ${item.is_archived === 0 ? 'Archive' : 'Activate'} this delivery request?`,
      });
      if (!confirm) return;
      if (!item || !item.id) return;

      const isActive = item.is_archived === 1 ? 0 : 1;
      const res = await this.$api.truckScheduleRequest.get(`toggle-archive/${item.id}/${isActive}`);
      if (!res) {
        this.$bus.$emit('showError', 'Unable to archive delivery request');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.getScheduledDeliveries({ start: this.start, end: this.end });
      this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      this.getTruckRequests();
    },

    approveTruckRequest(item) {
      if (!item || !item.id) return;
      const options = {
        isApprove: true,
      }
      this.$refs.truckScheduleRequestForm.open(item.id, options);
    },

    openTruckRequestForm(item, isView = false) {
      if (!item) {
        this.$refs.truckScheduleRequestForm.open();
      } else {
        const options = {
          isView: isView
        }
        this.$refs.truckScheduleRequestForm.open(item.id, options);
      }
    },

    openBillOfLadingList(item) {
      this.$refs.billOfLadingList.open(item);
    },

    openManualScheduleForm(item) {
      this.$refs.truckScheduleManualScheduleForm.open(item, this.events);
    },

    async softDeleteScheduledDelivery(id) {
      const confirm = await this.$refs.confirmForm.open({
        title:
          'Are you sure that you want to delete this scheduled delivery? All associated delivery requests and bill of ladings will be unassigned.',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.truckScheduleSlot.delete(id);

      if (!res) {
        this.$bus.$emit('showError', 'Unable to delete scheduled delivery');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.getTruckRequests();
      this.getScheduledDeliveries({ start: this.start, end: this.end });
    },

    onDragStart(ev, item, itemId) {
      // ev.dataTransfer.setData("text", ev.target.id);
      ev.dataTransfer.setData('application/json', JSON.stringify(item));

      // Use the row element as the drag image
      this.createDragImage(ev, itemId);

      this.isAddEventDisabled = false;
    },

    createDragImage(ev, itemId) {
      const rowElement = this.$refs[`row-${itemId}`]; // Get the row element
      if (rowElement) {
        const clone = rowElement.cloneNode(true); // Clone the row for a snapshot

        this.copyStyles(rowElement, clone);

        clone.style.position = 'absolute';
        clone.style.top = '-9999px'; // Hide it off-screen
        document.body.appendChild(clone); // Append it to the DOM
        ev.dataTransfer.setDragImage(clone, 0, 0); // Use it as the drag image

        // Clean up the cloned element after dragging
        setTimeout(() => document.body.removeChild(clone), 0);
      }
    },

    copyStyles(source, target) {
      const computedStyle = window.getComputedStyle(source);
      for (const key of computedStyle) {
        target.style[key] = computedStyle.getPropertyValue(key);
      }

      // Recursively copy styles for child elements
      for (let i = 0; i < source.children.length; i++) {
        this.copyStyles(source.children[i], target.children[i]);
      }
    },

    openScheduledDeliveryForm(item) {
      this.$refs.truckScheduledDeliveryForm.open(item.id);
    },

    success({ getTruckRequests = true, getScheduledDeliveries = true, getAvailableTrucks = true } = {}) {
      if (getTruckRequests) {
        this.getTruckRequests();
      }
      if (getScheduledDeliveries) {
        this.getScheduledDeliveries({ start: this.start, end: this.end });
      }
      if (getAvailableTrucks) {
        this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      }
    },

    async manualScheduleSuccess(oldSlotId) {
      // this.$bus.$emit('showSuccess');
      // this.getTruckRequests();
      // this.getScheduledDeliveries({ start: this.start, end: this.end });
      if (oldSlotId) {
        // const submitModel = {
        //   filters: {
        //     id: oldSlotId,
        //   },
        // };
        // const res = await this.$api.truckScheduleSlot.read(submitModel);
        // const cancelCode = 3001;
        // if (res === cancelCode) return;
        // if (!res) {
        //   this.$bus.$emit('showError', 'Unable to retrieve delivery requests');
        //   return false;
        // }

        // const firstIndex = 0;
        // const oldSlot = res[firstIndex];
        // if (oldSlot.requests.length === 0) {
          this.$bus.$emit('loading');
          const res = await this.$api.truckScheduleSlot.delete(oldSlotId);
          this.$bus.$emit('loading-stop');
          if (!res) {
            this.$bus.$emit('showError', 'Error deleting scheduled delivery');
            return false;
          }
        // }
      }

      this.$bus.$emit('showSuccess');
      this.getScheduledDeliveries({ start: this.start, end: this.end });
      this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      this.getTruckRequests();
    },

    onDragEnd(event) {
      // console.log('onDragEnd');
      this.isAddEventDisabled = true;
    },

    // async onDropExistingEvent(ev, event) {
    //   this.$bus.$emit('loading');
    //   // console.log('Dropped on $event: ', ev);
    //   // console.log('Dropped on evenet: ', event);

    //   //set this truck request's slot_id to equal the event.id
    //   const truckRequest = JSON.parse(
    //     ev.dataTransfer.getData('application/json')
    //   );
    //   // need to check if the truck request is pending
    //   // if it is then need to check if the event is pending then allow drop, otherwise show error 'Truck Request must be dropped in a Pending Scheduled Delivery'
    //   if (this.isTruckRequestPending(truckRequest) && !this.isScheduledDeliveryPending(event)) {
    //     this.$bus.$emit('loading-stop');
    //     this.$bus.$emit(
    //       'showError',
    //       `Pending Truck Request must be dropped in a Pending Scheduled Delivery`
    //     );
    //     return;
    //   }

    //   if (this.isTruckRequestPickup(truckRequest) && !this.isTruckRequestPending(truckRequest) && !this.isScheduledDeliveryPickup(event)) {
    //     this.$bus.$emit('loading-stop');
    //     this.$bus.$emit(
    //       'showError',
    //       `Pickup Truck Request must be dropped in a Pickup Scheduled Delivery`
    //     );
    //     return;
    //   }

    //   if (!this.isTruckRequestPickup(truckRequest) && !this.isTruckRequestPending(truckRequest)) {
    //     if (this.isScheduledDeliveryPending(event)) {
    //       this.$bus.$emit('loading-stop');
    //       this.$bus.$emit(
    //         'showError',
    //         `Truck Request must be Pending to be dropped in a Pending Scheduled Delivery`
    //       );
    //       return;
    //     }
    //     if (this.isScheduledDeliveryPickup(event)) {
    //       this.$bus.$emit('loading-stop');
    //       this.$bus.$emit(
    //         'showError',
    //         `Truck Request must be Pickup to be dropped in a Pickup Scheduled Delivery`
    //       );
    //       return;
    //     }
    //     if (!this.isSameClass(truckRequest, event)) {
    //       const scheduledDeliveryClassName = event.requests[0].class.name;
    //       this.$bus.$emit('loading-stop');
    //       this.$bus.$emit(
    //         'showError',
    //         `Truck Request must be same class as Scheduled Delivery (${scheduledDeliveryClassName})`
    //       );
    //       return;
    //     }
    //   }

    //   if (this.isExistingJobInScheduledDelivery(truckRequest, event)) {
    //     this.$bus.$emit('loading-stop');
    //     this.$bus.$emit(
    //       'showError',
    //       `A Truck Request of this ${this.jobLabel} already exists in this Scheduled Delivery`
    //     );
    //     return;
    //   }

    //   truckRequest.slot_id = event.id;
    //   truckRequest.status_id = this.truckScheduleStatusIdInProgress;

    //   const res = await this.$api.truckScheduleRequest.update(truckRequest);

    //   this.isAddEventDisabled = true;
    //   if (!res) {
    //     this.$bus.$emit('loading-stop');
    //     this.$bus.$emit(
    //       'showError',
    //       `Error adding Delivery Request to Scheduled Delivery ${event.name}`
    //     );
    //     return;
    //   }

    //   // deprecated
    //   // if (this.truckRequestHasUnactivatedPickLists(truckRequest)) {
    //   //   const isActive = 1;
    //   //   const res2 = await this.$api.partPickList.get(`is-active/truck-schedule-request/${truckRequest.id}/${isActive}`);
    //   //   if (!res2) {
    //   //     this.$bus.$emit('loading-stop');
    //   //     this.$bus.$emit(
    //   //       'showError',
    //   //       `Error activating Pick List for Truck Schedule Request`
    //   //     );
    //   //     return;
    //   //   }
    //   // }
    //   this.$bus.$emit('loading-stop');
    //   this.$bus.$emit('showSuccess');
    //   this.getScheduledDeliveries({ start: this.start, end: this.end });
    //   this.getTruckRequests();
    // },

    // isSameClass(truckRequest, event) {
    //   // console.log('isSameClass truckRequest: ', truckRequest);
    //   // console.log('isSameClass event: ', event);
    //   if (event.requests == null || event.requests.length <= 0) return true;
    //   return truckRequest.inventory_class_id === event.requests[0].class.id;
    // },

    // isExistingJobInScheduledDelivery(truckRequest, event) {
    //   // console.log('isExistingJob truckRequest: ', truckRequest);
    //   // console.log('isExistingJob event: ', event);
    //   const jobId = truckRequest.job_id;
    //   if (jobId === null) return false;
    //   const requests = Array.isArray(event.requests) ? event.requests : [];
    //   return requests.some((x) => x.job_id === jobId);
    // },

    // isExistingJobAcrossScheduledDeliveryDate(truckRequest, date) {
    //   const jobId = truckRequest.job_id;
    //   if (jobId === null) return false;
    //   return this.events
    //     .filter((event) => event.date === date)
    //     .some((event) =>
    //       event.requests.some((request) => request.job_id === jobId)
    //     );
    // },

    // isExistingInventoryClassAcrossScheduledDeliveryDate(truckRequest, date) {
    //   const inventoryClassId = truckRequest.inventory_class_id;
    //   return this.events
    //     .filter((event) => event.date === date)
    //     .some((event) =>
    //       event.requests.some(
    //         (request) => request.inventory_class_id === inventoryClassId
    //       )
    //     );
    // },

    // isExistingInventoryClassAcrossNonPendingAndNonPickupScheduledDeliveryDate(truckRequest, date) {
    //   const inventoryClassId = truckRequest.inventory_class_id;
    //   return this.events
    //     .filter((event) => event.date === date)
    //     .some((event) =>
    //       event.requests.some(
    //         (request) =>
    //           request.inventory_class_id === inventoryClassId &&
    //           request.request_shift_id !== this.truckScheduleRequestShiftIdPending &&
    //           request.request_type_id !== this.truckScheduleRequestTypeIdPickup
    //       )
    //     );
    // },

    isTruckRequestPending(truckRequest) {
      return truckRequest.request_shift_id === this.truckScheduleRequestShiftIdPending;
    },

    isTruckRequestPickup(truckRequest) {
      return truckRequest.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    isScheduledDeliveryPending(event) {
      // return event.requests.some(
      //   (request) => request.request_shift_id === this.truckScheduleRequestShiftIdPending
      // );
      return event.request && event.request.request_shift_id === this.truckScheduleRequestShiftIdPending;
    },

    isScheduledDeliveryPickup(event) {
      // return event.requests.some(
      //   (request) => request.request_type_id === this.truckScheduleRequestTypeIdPickup
      // );
      return event.request && event.request.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    isScheduledDeliveryNonPendingPickup(event) {
      // return event.requests.some(
      //   (request) =>
      //     request.request_shift_id !== this.truckScheduleRequestShiftIdPending &&
      //     request.request_type_id === this.truckScheduleRequestTypeIdPickup
      // );
      return event.request && event.request.request_shift_id !== this.truckScheduleRequestShiftIdPending && event.request.request_type_id === this.truckScheduleRequestTypeIdPickup;
    },

    // isExistingPendingAcrossScheduledDeliveryDate(date) {
    //   return this.events
    //     .filter((event) => event.date === date)
    //     .some((event) => this.isScheduledDeliveryPending(event));
    // },

    isExistingPendingAcrossScheduledDeliveryDate(date) {
      const pendingScheduledDelivery = this.scheduledDeliveries
        .filter((sd) => sd.date === date)
        .find((sd) => this.isScheduledDeliveryPending(sd));

      return pendingScheduledDelivery ? pendingScheduledDelivery.id : null;
    },

    // isExistingPickupAcrossScheduledDeliveryDate(date) {
    //   return this.events
    //     .filter((event) => event.date === date)
    //     .some((event) => this.isScheduledDeliveryPickup(event));
    // },

    // isTruckRequestAndScheduledDeliveryPending(truckRequest, event) {
    //   const isTruckRequestPending = truckRequest.request_shift_id === this.truckScheduleRequestShiftIdPending;
    //   const requests = Array.isArray(event.requests) ? event.requests : [];
    //   const isScheduledDeliveryPending =  requests.some((x) => x.request_shift_id === this.truckScheduleRequestShiftIdPending);
    //   return isTruckRequestPending && isScheduledDeliveryPending;
    // },

    truckRequestHasBillOfLadings(truckRequest) {
      return truckRequest.bill_of_ladings.length > 0;
    },

    truckRequestHasSuppliedPickList(truckRequest) {
      return truckRequest.pick_list && (truckRequest.pick_list.status_id === this.pickListStatusIdSupplied || truckRequest.pick_list.status_id === this.pickListStatusIdPartiallySupplied || truckRequest.pick_list.status_id === this.pickListStatusIdShipped);
    },

    truckRequestIsComplete(truckRequest) {
      return truckRequest.status_id === this.truckScheduleStatusIdComplete;
    },

    scheduledDeliveryHasBillOfLadings(event) {
      // return event.requests.some(
      //   (request) => request.bill_of_ladings.length > 0
      // );
      return event.request && event.request.bill_of_ladings.length > 0;
    },

    scheduledDeliveryHasSuppliedPickList(event) {
      // return event.requests.some(
      //   (request) =>
      //     request.pick_list &&
      //     (
      //       request.pick_list.status_id === this.pickListStatusIdPartiallySupplied ||
      //       request.pick_list.status_id === this.pickListStatusIdSupplied ||
      //       request.pick_list.status_id === this.pickListStatusIdShipped
      //     )
      // );
      return event.request && event.request.pick_list &&
        (
          event.request.pick_list.status_id === this.pickListStatusIdPartiallySupplied ||
          event.request.pick_list.status_id === this.pickListStatusIdSupplied ||
          event.request.pick_list.status_id === this.pickListStatusIdShipped
        );
    },

    scheduledDeliveryHasCompleteTruckRequests(event) {
      // return event.requests.some(
      //   (request) => request.status_id === this.truckScheduleStatusIdComplete
      // );
      return event.request && event.request.status_id === this.truckScheduleStatusIdComplete;
    },

    truckRequestIsNotAssigned(truckRequest) {
      return truckRequest.slot === null;
    },

    truckRequestIsScheduled(truckRequest) {
      // return truckRequest.slot !== null;
      return truckRequest.status_id === this.truckScheduleStatusIdScheduled;
    },

    isTruckRequestEditDisabled(truckRequest) {
      if (!truckRequest || !this.truckRequestIsScheduled(truckRequest) || !truckRequest.slot || !truckRequest.slot.date) return false;
      const firstDisabledDate = moment(truckRequest.slot.date).add(1, 'days');
      return moment(this.currentDate).isSameOrAfter(firstDisabledDate, 'day');
    },

    truckRequestHasUnactivatedPickLists(truckRequest) {
      if (Array.isArray(truckRequest.pick_lists) && truckRequest.pick_lists.length > 0) {
        return truckRequest.pick_lists.some((pl) => pl.is_active === 0);
      }
      return false;
    },

    truckRequestIsCanceled(truckRequest) {
      return truckRequest.status_id == this.truckScheduleStatusIdCanceled;
    },

    truckRequestIsRequested(truckRequest) {
      return truckRequest.status_id == this.truckScheduleStatusIdRequested;
    },

    truckRequestIsPendingApproval(truckRequest) {
      return truckRequest.status_id === this.truckScheduleStatusIdPendingApproval;
    },

    truckRequestIsPendingScheduling(truckRequest) {
      return truckRequest.status_id === this.truckScheduleStatusIdPendingScheduling;
    },

    truckRequestIsInProgress(truckRequest) {
      return truckRequest.status_id === this.truckScheduleStatusIdInProgress;
    },

    onCalendarDrop(event) {
      console.log('Dropped on calendar');
    },

    onDragOver(event, date) {
      event.preventDefault();
      this.isDraggingOverDate = date;
    },

    onDragLeave() {
      this.isDraggingOverDate = null;
    },

    async onDropNewEvent(ev, dayLabelHeader) {
      this.$bus.$emit('loading');
      // console.log('onDropNewEvent ev: ', ev);
      const truckRequest = JSON.parse(
        ev.dataTransfer.getData('application/json')
      );
      // console.log('draggedItem: ', truckRequest);
      // console.log('dayLabelHeader: ', dayLabelHeader);
      // if truck request is penidng then need to check if there's already a pending scheduled delivery for this date
      // if pending scheduled delivery exists then show error 'A Pending Scheduled Delivery already exists for this date'
      // if (this.isTruckRequestPending(truckRequest) && this.isExistingPendingAcrossScheduledDeliveryDate(dayLabelHeader.date)) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit(
      //     'showError',
      //     `A Pending Scheduled Delivery already exists for this date`
      //   );
      //   return;
      // }

      // if (this.isTruckRequestPickup(truckRequest) && !this.isTruckRequestPending(truckRequest) && this.isExistingPickupAcrossScheduledDeliveryDate(dayLabelHeader.date)) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit(
      //     'showError',
      //     `A Pickup Scheduled Delivery already exists for this date`
      //   );
      //   return;
      // }

      // if (!this.isTruckRequestPickup(truckRequest) && !this.isTruckRequestPending(truckRequest) && this.isExistingInventoryClassAcrossNonPendingAndNonPickupScheduledDeliveryDate(truckRequest, dayLabelHeader.date)) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit(
      //     'showError',
      //     `A Scheduled Delivery already exists with this Inventory Class for this date`
      //   );
      //   return;
      // }

      // if (this.isExistingJobAcrossScheduledDeliveryDate(truckRequest, dayLabelHeader.date)) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit(
      //     'showError',
      //     `A Scheduled Delivery already exists with this Job for this date`
      //   );
      //   return;
      // }

      // const newTruckSchedule = {
      //   id: 0,
      //   // truck_schedule_request_id: truckRequest.id,
      //   requests: [truckRequest],
      //   date: dayLabelHeader.date,
      // };
      // //submit a new truck_schedule_slot
      // const res = await this.$api.truckScheduleSlot.store(newTruckSchedule);
      const date = dayLabelHeader.date;
      // if (this.isExistingJobAcrossScheduledDeliveries(truckRequest, date)) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', `A Scheduled Delivery already exists with this ${this.jobLabel} for this date`);
      //   return;
      // }

      // const res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest, date);
      // this.$bus.$emit('loading-stop');
      // this.isDraggingOverDate = null;
      // if (this.isTruckRequestNonPendingPickup(truckRequest)) {
      //   const pickupScheduledDeliveryId = this.isExistingNonPendingPickupAcrossScheduledDeliveryDate(date);  //done
      //   if (pickupScheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(truckRequest, pickupScheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest, date);
      //   }
      // } else if (this.isTruckRequestPending(truckRequest)) {
      //   const pendingScheduledDeliveryId = this.isExistingPendingAcrossScheduledDeliveryDate(date); //done
      //   if (pendingScheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(truckRequest, pendingScheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest, date);
      //   }
      // } else {
      //   const scheduledDeliveryId = this.isExistingInventoryClassAcrossScheduledDeliveries(truckRequest, date); //done
      //   if (scheduledDeliveryId) {
      //     res = await this.addTruckRequestToScheduledDelivery(truckRequest, scheduledDeliveryId);
      //   } else {
      //     res = await this.createNewScheduledDeliveryAndAddTruckRequest(truckRequest, date);
      //   }
      // }

      const newTruckSchedule = {
        id: 0,
        request: truckRequest,
        date: date,
      };
      //submit a new truck_schedule_slot
      const res = await this.$api.truckScheduleSlot.store(newTruckSchedule);

      this.$bus.$emit('loading-stop');
      this.isDraggingOverDate = null;

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return;
      }

      if (!res) {
        this.$bus.$emit('showError', 'Unable to schedule truck request');
        return;
      }

      // if (!res) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', 'Unable to create new Scheduled Delivery');
      //   return false;
      // }

      // deprecated
      // if (this.truckRequestHasUnactivatedPickLists(truckRequest)) {
      //   const isActive = 1;
      //   const res2 = await this.$api.partPickList.get(`is-active/truck-schedule-request/${truckRequest.id}/${isActive}`);
      //   if (!res2) {
      //     this.$bus.$emit('loading-stop');
      //     this.$bus.$emit(
      //       'showError',
      //       `Error activating Pick List for Truck Schedule Request`
      //     );
      //     return;
      //   }
      // }
      //on success, show success message and refresh the calendar
      this.$bus.$emit('showSuccess');
      this.getScheduledDeliveries({ start: this.start, end: this.end });
      this.getAvailableTrucksByDate({ start: this.start, end: this.end });
      this.getTruckRequests();
    },

    async createNewScheduledDeliveryAndAddTruckRequest(truckRequest, date) {
      //will always be null if scheduling from scratch
      // truckRequest.slot_id = null;
      const newTruckSchedule = {
        id: 0,
        request: truckRequest,
        date: date,
      };
      //submit a new truck_schedule_slot
      const res = await this.$api.truckScheduleSlot.store(newTruckSchedule);

      if (!res) {
        return false;
      }
      return true
    },

    async addTruckRequestToScheduledDelivery(truckRequest, scheduledDeliveryId) {
      truckRequest.slot_id = scheduledDeliveryId;
      truckRequest.status_id = this.truckScheduleStatusIdInProgress;

      let res;
      try {
        res = await this.$api.truckScheduleRequest.update(truckRequest);
      } catch (error) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit(
          'showError',
          error.response && typeof error.response.data === 'string' && error.response.data
            ? error.response.data
            : 'Error adding Truck Request to Scheduled Delivery'
        );
        return false;
      }

      if (!res) {
        this.$bus.$emit(
          'showError',
          `Error adding Truck Request to Scheduled Delivery`
        );
        return false;
      }
      return true;
    },

    // isExistingInventoryClassAcrossScheduledDeliveries(truckRequest, date) {
    //   // instead of only checking if there's a scheduled delivery with the same inventory class, we need to return the id of the scheduled delivery
    //   const inventoryClassId = truckRequest.inventory_class_id;
    //   const scheduledDelivery = this.scheduledDeliveries
    //     .filter((sd) => sd.date === date)
    //     .find((sd) =>
    //       sd.requests.some(
    //         (r) => r.inventory_class_id === inventoryClassId
    //       )
    //     );
      
    //   return scheduledDelivery ? scheduledDelivery.id : null;
    // },

    // isExistingJobAcrossScheduledDeliveries(truckRequest, date) {
    //   const jobId = truckRequest.job_id;
    //   return this.scheduledDeliveries
    //     .filter((sd) => sd.date === date)
    //     .some((sd) =>
    //       sd.requests.some((r) => r.job_id === jobId)
    //     );
    // },

    isTruckRequestNonPendingPickup(truckRequest) {
      return !this.isTruckRequestPending(truckRequest) && this.isTruckRequestPickup(truckRequest);
    },

    isExistingNonPendingPickupAcrossScheduledDeliveryDate(date) {
      const pickupScheduledDelivery = this.scheduledDeliveries
        .filter((sd) => sd.date === date)
        .find((sd) => this.isScheduledDeliveryNonPendingPickup(sd));

      return pickupScheduledDelivery ? pickupScheduledDelivery.id : null;
    },

    async completeTruckRequest(item) {
      if(!item) return;
      if(item.request_type_id !== this.truckScheduleRequestTypeIdPickup) {
        this.$bus.$emit('showError', 'Only Pickup Truck Requests can be completed');
        return;
      }
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to complete this Pickup Truck Request?',
      });
      if (!confirm) return;
      const res = await this.$api.truckScheduleRequest.get(`complete/${item.id}`);
      if (!res) {
        this.$bus.$emit('showError', 'Error completing truck request');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.success({ getTruckRequests: true, getScheduledDeliveries: true, getAvailableTrucks: false });
    },

    belongsToRequester(item) {
      return item.created_by_user.id === this.user.id;
    },

    isTruckRequestApproved(item) {
      //item is truck request
      if (!item) return false;
      return item.status_id !== this.truckScheduleStatusIdRequested;
    },

    isTruckRequestApprovedByDeliveryManager(item) {
      if (!item) return false;
      return true;
    },

    isTruckRequestApprovedByDeliveryRequester(item) {
      if (!item) return false;
      return true;
    },

    isTruckRequestArchived(item) {
      if (!item) return false;
      return item.is_archived === 1;
    },

    // isRequested(item) {

    // },

    // getEventColor(event) {
    //   // const baseColor =
    //   //   event.requests && event.requests[0] && event.requests[0].class
    //   //     ? event.requests[0].class.color
    //   //     : '#757575';
    //   // const lighterColor = this.lightenColor(baseColor, 20); // 20% lighter
    //   // return `linear-gradient(45deg, ${baseColor}, ${lighterColor})`;
    //   return event.requests && event.requests[0] && event.requests[0].class
    //     ? event.requests[0].class.color
    //     : '#757575';
    // },
    getEventBorderColor(event) {
      if (this.isScheduledDeliveryPending(event)) {
        return this.scheduledDeliveryCardPendingColor;
      }
      return event.request && event.request.request_type ? event.request.request_type.color : '#757575';
      // return event.requests && event.requests[0] && event.requests[0].class
      //   ? event.requests[0].class.color
      //   : '#757575';
    },
    getEventBackgroundColor(event) {
      // if (this.isScheduledDeliveryPending(event)) {
      //   return this.scheduledDeliveryCardPendingColor;
      // }
      return '#FFFFFF';
    },
    // lightenColor(color, percent) {
    //   const num = parseInt(color.slice(1), 16),
    //     amt = Math.round(2.55 * percent),
    //     R = (num >> 16) + amt,
    //     G = ((num >> 8) & 0x00ff) + amt,
    //     B = (num & 0x0000ff) + amt;
    //   return `#${(
    //     0x1000000 +
    //     (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    //     (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
    //     (B < 255 ? (B < 1 ? 0 : B) : 255)
    //   )
    //     .toString(16)
    //     .slice(1)
    //     .toUpperCase()}`;
    // },

    onResize() {
      this.windowHalfHeight = (window.innerHeight - this.topSpaceHeight) / 2;
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      // this.storeState('pagination', newOptions);
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      }
    },

    viewDay({ date }) {
      this.focusDay = date;
      this.type = 'day';
    },

    // setToday() {
    //   this.type = 'day';
    //   this.focusDay = '';
    // },

    prev() {
      // console.log('prev');
      // console.log('this.$refs.calendar: ', this.$refs.calendar);
      this.$refs.calendar.prev();
    },

    next() {
      // console.log('next');
      // console.log('this.$refs.calendar: ', this.$refs.calendar);
      this.$refs.calendar.next();
    },

    async getHolidays() {
      this.loading = true;
      const submitModel = {
        filters: {},
      };
      this.holidays = await this.$api.timeOffHoliday.read(submitModel);
      this.loading = false;
    },

    setHolidaysObj() {
      if (this.holidays.length > 0) {
        this.holidays.forEach((holiday) => {
          this.holidaysObj[holiday.date] = holiday.name;
        });
      } else {
        this.holidaysObj = {};
        this.holidays = [];
      }
    },

    dropEventColorClass(date) {
      // if date is greater than or equal to today, return the class 'drop-event' else return nothing
      if (moment(date).isSameOrAfter(this.currentDate)) {
        return 'drop-event-btn';
      }
    },

    draggingOverClass(date) {
      if (this.isDraggingOverDate === date) {
        return 'dragging-over-btn';
      }
      return '';
    },

    getEventHeight(event) {
      const maxTotalRows = 5;
      const headerRows = 1;
      const maxItemRows = maxTotalRows - headerRows - 1; // reserve 1 row for "+more" if needed => 3

      const headerHeight = 57;
      const itemRowHeight = 36;
      const moreRowHeight = 48;

      const request = event?.request || {};

      const jobs = Array.isArray(request.jobs) ? request.jobs : [];

      const showProjects = this.shouldShowProjects(request);
      let projectsNotInJobs = [];
      if (showProjects && Array.isArray(request.projects)) {
        projectsNotInJobs = this.getProjectsNotInJobs(request.projects, request.jobs);
      }

      // Build the *combined* item list in the same order you render them.
      // Jobs first, then projects-not-in-jobs.
      const combinedItems = [
        ...jobs.map(j => ({ type: "job", data: j })),
        ...projectsNotInJobs.map(p => ({ type: "project", data: p })),
      ];

      // Figure out what can be shown in the 3 item rows
      const visibleItems = combinedItems.slice(0, maxItemRows);
      const hiddenCount = Math.max(0, combinedItems.length - visibleItems.length);

      // Height calculation based on rows actually rendered
      let height = 0;
      height += headerHeight;                         // header row
      height += visibleItems.length * itemRowHeight;  // up to 3 item rows

      if (hiddenCount > 0) {
        height += moreRowHeight;                      // single "+X more" row
      }

      return height;
    },

    mapJobsAndProjectsToListItem(request) {
      let listItems = [];
      //for each job in request, append it to listItems with the same data but type_id = 'job'
      //for each project in request that doesn't derive from a job, append it to listItems with the same data but type_id = 'project'
      if (request.jobs) {
        request.jobs.forEach(job => {
          listItems.push({
            ...job,
            type_id: 'job',
          });
        });
      }
      const showProjects = this.shouldShowProjects(request);
      const projectsNotInJobs = showProjects && request.projects ? this.getProjectsNotInJobs(request.projects, request.jobs) : [];
      if (showProjects && projectsNotInJobs.length > 0) {
        projectsNotInJobs.forEach(project => {
          listItems.push({
            ...project,
            type_id: 'project',
          });
        });
      }
      return listItems;
    },

    shouldShowProjects(request) {
      //only show projects if the request exists and the request type is pickup or non-window delivery
      return request && (request.request_type_id === this.truckScheduleRequestTypeIdPickup || request.request_type_id === this.truckScheduleRequestTypeIdNonWindowDelivery);
    },

    showMoreText(event) {
      const maxNumberOfItemsToShow = 3;
      let numberOfItems = 0;
      let numberOfJobs = event.request && event.request.jobs ? event.request.jobs.length : 0;
      numberOfItems += numberOfJobs;
      if (this.shouldShowProjects(event.request)) {
        let numberOfProjects = 0;
        if (event.request.projects) {
          // const projectsNotInJobs = event.request.projects.filter(project => {
          //   return !event.request.jobs || !event.request.jobs.some(job => job.project_id === project.id);
          // });
          const projectsNotInJobs = this.getProjectsNotInJobs(event.request.projects, event.request.jobs);
          numberOfProjects = projectsNotInJobs.length;
        }
        numberOfItems += numberOfProjects;
      }
      if (numberOfItems > maxNumberOfItemsToShow) {
        const remainingItems = numberOfItems - maxNumberOfItemsToShow;
        return `+${remainingItems} more`;
      }
      return null;
    },

    getProjectsNotInJobs(requestProjects, requestJobs) {
      if (!requestProjects) return [];
      if (!requestJobs) return requestProjects;
      return requestProjects.filter(project => {
        return !requestJobs.some(job => job.project_id === project.id);
      });
    },

    lightenColor(hex) {
      // Remove the '#' if it exists
      let normalizedHex = hex.replace('#', '');

      // If the hex is in shorthand form (e.g., "abc"), convert it to full form ("aabbcc")
      if (normalizedHex.length === 3) {
        normalizedHex = normalizedHex
          .split('')
          .map(char => char + char)
          .join('');
      }

      // Ensure we have exactly 6 characters now
      if (normalizedHex.length !== 6) {
        throw new Error("Invalid hex color format. Please use '#RRGGBB' or '#RGB'.");
      }

      // Convert the R, G, and B components from hex to decimal
      const r = parseInt(normalizedHex.slice(0, 2), 16);
      const g = parseInt(normalizedHex.slice(2, 4), 16);
      const b = parseInt(normalizedHex.slice(4, 6), 16);

      // Return the rgba string with an alpha of 0.12
      return `rgba(${r}, ${g}, ${b}, 0.12)`;
    },

    getTotalAvailableTrucksCount(date) {
      const availableTrucksForDate = this.availableTrucksByDate[date];
      //data looks like this:
      // {
      //   "2026-03-02": [
      //     { "truck_type_id": 1, "truck_type_name": "1 Ton", "count": 3 },
      //     { "truck_type_id": 2, "truck_type_name": "5 Ton", "count": 1 }
      //   ],
      //   "2026-03-03": [
      //     { "truck_type_id": 1, "truck_type_name": "1 Ton", "count": 2 }
      //   ]
      // }
      if (availableTrucksForDate) {
        // return availableTrucksForDate.length;
        //for each truck type, sum the count to get the total number of available trucks for that date
        return availableTrucksForDate.reduce((total, truckType) => total + truckType.count, 0);
      }
      return 0;

    },

    async openGenerateReportDialog() {
      this.$refs.dialogBox.open();
    },

    async runWebhook() {
      this.$bus.$emit('loading');
      const webhookModuleIdScheduledDeliveries = 60;
      const fromDate = this.webhookDates[0];
      const toDate = this.webhookDates[1];

      if(!fromDate) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Please select a start date for the report');
        return;
      }
      if(!toDate) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Please select an end date for the report');
        return;
      }

      const webhookData = {
        module_id: webhookModuleIdScheduledDeliveries,
        from_date: fromDate,
        to_date: toDate,
      };

      const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError');
        return;
      }

      const now = FormatHelpers.getFileTimestamp();
      const fileName = `Scheduled_Delivery_${now}`;

      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess');
      this.$refs.dialogBox.close();
    },
  },
};
</script>
<style scoped>
/* ::v-deep .theme--light.v-calendar-daily .v-calendar-daily__intervals-body {
  display: none !important;
}
::v-deep .theme--light.v-calendar-daily .v-calendar-daily__intervals-head {
  display: none !important;
} */
/* ::v-deep .v-calendar-daily__body{
  display: none;
} */
::v-deep .v-calendar-daily__intervals-head {
  display: none !important;
}
::v-deep .v-calendar-daily__scroll-area {
  overflow-y: hidden !important;
}
/* first column in calendar monthly view */
/* /deep/.v-calendar-weekly__week .v-calendar-weekly__day:first-child {
  background-color: #ffecef;
} */
/* last column in calendar monthly view */
/deep/.v-calendar-weekly__week .v-calendar-weekly__day:last-child {
  background-color: #ffecef;
}
/* first column in calendar monthly view */
/* /deep/.v-calendar-weekly__head .v-calendar-weekly__head-weekday:first-child {
  background-color: #ffecef;
} */
/* last column in calendar monthly view */
/deep/.v-calendar-weekly__head .v-calendar-weekly__head-weekday:last-child {
  background-color: #ffecef;
}
/deep/.v-calendar-daily__head .v-calendar-daily_head-day:nth-child(7) {
  background-color: #ffecef;
}
/* /deep/.v-calendar-daily__head
  > .v-calendar-daily_head-day:nth-child(2):nth-last-child(7) {
  background-color: #ffecef;
}
/deep/.v-calendar-daily__day-container
  > .v-calendar-daily__day:nth-child(2):nth-last-child(7) {
  background-color: #ffecef;
} */
/deep/.v-calendar-daily__day:nth-child(7) {
  background-color: #ffecef;
}
/deep/.v-calendar-daily_head-day-label {
}
/deep/.calendar-add-event {
  color: var(--v-primary-base);
  border: 2px solid var(--v-primary-base);
  border-radius: 5px;
  margin: 1rem;
}
/deep/.v-calendar-daily_head-day-label {
  cursor: default !important;
}
/deep/#drop-event-btn.drop-event-btn {
  color: var(--v-primary-base) !important;
}
/deep/#drop-event-btn.dragging-over-btn {
  color: white !important;
  background-color: var(--v-primary-base) !important;
}
/deep/.v-event {
  min-height: 50px !important;
  height: auto !important;
  width: 98% !important;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
}
.truncate-text {
  font-size: clamp(0.7rem, 1.2vw, 1rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%; /* optional: constrain width to parent container */
}
.day-header-actions {
  position: relative;
}

.truck-indicator {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
}
/* .calendar-container {
  height: 400px;
  overflow-y: auto;
} */

/* .v-calendar-weekly {
  display: table;
  table-layout: fixed;
}
.v-calendar-weekly__week {
  height: auto;
  display: table-row;
}
.v-calendar-weekly__day {
  display: table-cell;
  width: calc(100% / 7);
} */
</style>